/**
 * Space Configurator — planificador de espacios multi-gama
 * Coloca productos de CUALQUIER gama registrada en SpaceCatalog dentro de una
 * sala a escala real (mm↔mundo), con auto-relleno + edición manual, vista
 * 3D/planta, precios cross-market y carrito multi-línea.
 */
(function () {

  // Escala única mundo↔mm — de facto la de RIVET 180cm (2.0 unidades ≈ 1840mm).
  // Cada modelo se mide en fresh-load (visibleBox) y se escala para que SU
  // altura física real (footprintMM) cumpla esta escala, no una constante
  // dura por gama — así todas las gamas quedan coherentes entre sí.
  var MM_TO_WORLD = 2.0 / 1840;
  function mm(v) { return v * MM_TO_WORLD; }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  // ─── i18n ────────────────────────────────────────────────────────────────────
  // Mismo patrón EXACTO que configurator.js:62-98 de los configuradores de
  // producto: el Liquid emite `window.SpaceConfiguratorData.i18n` con claves
  // PLANAS y este mapa es el respaldo castellano (prototipo local, o una clave
  // que el Liquid todavía no emita). Los nombres de clave son un CONTRATO
  // compartido con el Liquid, con index.html y con space-catalog.js
  // (labelKey/useCaseKey/unitKey) — no renombrar, no inventar claves nuevas.
  // Este mapa es la ÚNICA excepción legítima al "cero castellano" del JS.
  var I18N_DEFAULTS = {
    /* Reutilizadas del namespace configurator.* (ya traducido en los 10 locales) */
    f_anchura: 'Anchura', f_altura: 'Altura', f_fondo: 'Fondo', f_niveles: 'Niveles',
    f_tipo_balda: 'Tipo de balda', f_color: 'Color', niveles_word: 'niveles',
    v_malla: 'Malla galvanizada', v_madera: 'Tablero de madera',
    v_metalica: 'Metálica', v_aglomerado: 'Aglomerado',
    v_gris: 'Galvanizado', v_anthrazita: 'Gris Antracita', v_bicolor: 'Azul-Naranja',
    cap_shelf_lbl: 'Carga / balda', price_label: 'Precio', total_label: 'Total',
    adding: 'Añadiendo...', added: '✓ Añadido', cart_error: 'Error — Inténtalo de nuevo',
    no_stock: 'Sin stock', pdf_save: 'Guardar PDF', pdf_buy_now: 'Comprar ahora',
    pdf_view_config: 'Ver configuración',
    /* Ejes propios de palés + el módulo inicial/adicional (Media Carga y palés).
       También salen del namespace configurator.*, así que ya están traducidos en
       los 10 locales: no hay traducciones nuevas que subir para estas 9 claves. */
    f_protector: 'Protector de puntal', f_carga_pale: 'Carga por palé',
    f_tipo_modulo: 'Tipo de módulo',
    v_malla_no: 'Sin balda', v_malla_si: 'Malla galvanizada', v_si: 'Sí', v_no: 'No',
    v_mod_inicial: 'Inicial', v_mod_adicional: 'Adicional',

    /* space.dim.* — magnitudes de la sala */
    dim_ancho: 'Ancho', dim_fondo: 'Fondo', dim_alto: 'Alto',

    /* space.page.* — cabecera */
    page_title: 'Configurador 3D — Planifica tu espacio',
    page_subtitle: 'Introduce las medidas de tu espacio, elige el tipo de estantería y compón tu distribución a escala real.',

    /* space.steps.* — títulos del panel */
    step_room: '1 · Medidas de tu espacio', step_gama: '2 · Tipo de estantería',
    step_product: '3 · Medidas del producto', step_edit: 'Editar estantería seleccionada',
    step_layout: '4 · Distribución', step_summary: 'Resumen', room_apply: 'Aplicar medidas',

    /* space.viewer.* — visor, modos y cámara */
    mode_view: 'Mover vista', mode_edit: 'Editar',
    hint_view: 'Modo Mover vista: arrastra para orbitar la cámara. Un clic selecciona una estantería.',
    hint_edit: 'Modo Editar: arrastra una estantería para moverla. La cámara queda bloqueada (el zoom con la rueda sí funciona).',
    cam_front: 'Frontal', cam_side: 'Lateral', cam_fit: 'Encuadrar', cam_reset: 'Reset',
    view_plan: 'Vista en planta', view_3d: 'Vista 3D',
    tb_rotate: 'Rotar', tb_duplicate: 'Duplicar', tb_delete: 'Eliminar',
    loading: 'Cargando…',
    no_model: 'No hay modelo 3D disponible para esta configuración de {gama}',

    /* space.legend.* — leyenda de cotas (el código añade " (cm)" donde toca) */
    legend_wall: 'Distancia a pared', legend_item: 'Entre productos',
    legend_room: 'Medidas de tu espacio',

    /* space.layout.* — distribución */
    opt_aisle: 'Pasillo', opt_backtoback: 'Espalda con espalda',
    opt_aisledir: 'Dirección de las filas',
    aisledir_z: 'A lo ancho de tu espacio', aisledir_x: 'A lo largo de tu espacio',
    pattern_rows: 'Filas paralelas', pattern_perimeter: 'Perímetro',
    pattern_islands: 'Islas espalda-espalda', pattern_perimeter_islands: 'Perímetro + islas',
    add_manual: '+ Añadir una unidad',
    placed_n: 'Colocadas {n} unidades ({pattern})',
    placed_capped: '— límite alcanzado',
    placed_none: 'No caben unidades con estas medidas — reduce el pasillo o ajusta las medidas de tu espacio',

    /* space.layout.* — AÑADIDO EN FASE 2 (auto-relleno óptimo) */
    pattern_optimal: 'Distribución óptima',
    optimal_hint: 'Calcula la combinación de medidas que mejor aprovecha tu espacio',
    optimal_applied: 'Óptimo: {pattern} · {n} unidades · {m} m de balda',
    optimal_mixed: 'combinando medidas',
    calculating: 'Calculando la mejor distribución…',

    /* space.summary.* — resumen, carrito y avisos */
    items_empty: 'Todavía no hay estanterías colocadas.', units_word: 'unidades',
    add_all: 'Añadir todo al carrito', budget_pdf: 'Descargar presupuesto (PDF)',
    delete_all: 'Eliminar todos', share_btn: 'Compartir configuración',
    contact_btn: 'Consultar por email',
    added_partial: '✓ Añadido ({n} sin stock excluidas)',
    need_items_cart: 'Añade al menos una estantería antes de continuar',
    need_items_pdf: 'Añade al menos una estantería antes de generar el presupuesto',
    popup_blocked: 'Habilita las ventanas emergentes para generar el presupuesto',
    dev_mode: 'Modo desarrollo: revisa la consola (sin carrito real)',

    /* space.chain.* — cadena Inicial/Extensión */
    chain_demoted: 'Una Extensión se quedó sin Inicial adyacente — se ha convertido en Inicial automáticamente',
    chain_need_inicial: 'Añade primero un módulo Inicial (mismo alto y fondo) — sin Inicial no se puede añadir una Extensión',
    chain_cannot_switch: 'No se puede cambiar a Extensión — no hay un módulo Inicial compatible (mismo alto y fondo) en tu espacio',

    /* space.share.* — compartir y contacto */
    share_title: 'Compartir configuración', share_copy: 'Copiar enlace',
    share_copied: '✓ Copiado', share_wa: 'WhatsApp', share_email: 'Email',
    share_native_title: 'Planificador 3D — tu espacio',
    share_native_text: 'Mira esta distribución:',
    share_loaded: 'Configuración cargada desde el enlace compartido',
    mail_subject: 'Consulta de configuración — tu espacio {room}',
    mail_greeting: 'Hola', mail_intro: 'Estoy interesado en la siguiente distribución:',
    mail_room: 'Espacio', mail_none: '(Todavía no hay estanterías colocadas)',
    mail_total: 'Total estimado', mail_link: 'Enlace de configuración:',
    mail_thanks: 'Gracias',

    /* space.pdf.* — presupuesto */
    pdf_doc_title: 'Presupuesto — Configurador de espacios 3D',
    pdf_room: 'Tu espacio', pdf_plan_title: 'Plano en planta con distancias (cm)',
    pdf_col_product: 'Producto', pdf_col_qty: 'Cantidad',
    pdf_col_unit: 'Precio ud.', pdf_col_total: 'Total',
    pdf_total_est: 'Total estimado',
    pdf_buy_title_cart: 'Compra esta configuración online',
    pdf_buy_title_share: 'Revisa esta configuración online',
    pdf_buy_text_cart: 'Añade directamente al carrito todos los productos de esta distribución.',
    pdf_buy_text_share: 'Guarda o comparte el enlace para volver a esta distribución exacta.',

    /* space.gama.* — etiquetas, capacidad y uso por gama */
    gama_rivet_label: 'RIVET PRO', gama_versatile_label: 'Estantería 100% metal',
    gama_mediacarga_label: 'Media Carga (DLO)',
    gama_bullrack_label: 'BULLRACK RIVET PRO', gama_pallet_label: 'Estantería para palés',
    gama_sintornillos_label: 'Estantería sin tornillos',
    cap_up_to: 'hasta', cap_unit_shelf: 'kg/balda', cap_unit_pallet: 'kg/palé',
    cap_pallet_lbl: 'Carga / palé', pales_word: 'palés',
    gama_versatile_use: 'Oficinas, tiendas, trasteros y talleres: cajas, herramientas y archivo.',
    gama_rivet_use: 'Talleres y almacén general, montaje sin tornillos: cargas medias-altas por balda.',
    gama_mediacarga_use: 'Picking de carga pesada con módulos largos: almacenes y centros de distribución.',
    gama_bullrack_use: 'Talleres industriales y zonas de producción: la mayor carga por balda y anchos de 2 m.',
    gama_pallet_use: 'Palés con carretilla elevadora: almacenes logísticos y almacenamiento a granel.',
    gama_sintornillos_use: 'Montaje sin tornillos ni herramientas: trasteros, garajes y almacén ligero.',

    /* space.fit.* — encaje del producto en tu espacio (alto y pasillo) */
    fit_no_cabe: 'no cabe',
    fit_alto_msg: 'Tu espacio mide {sala} cm de alto y esta estantería necesita {alto} cm. Aumenta el alto en el paso 1.',
    fit_ninguna_altura: 'Ninguna medida de esta gama cabe en un espacio de {sala} cm de alto. Aumenta el alto en el paso 1.',
    fit_pasillo: 'Pasillo ajustado a {n} cm: esta gama se maneja con carretilla elevadora.',
    optimal_applied_pales: 'Óptimo: {pattern} · {n} módulos · {m} palés'
  };
  function t(key) {
    var i18n = window.SpaceConfiguratorData && window.SpaceConfiguratorData.i18n;
    if (i18n && i18n[key] !== undefined && i18n[key] !== '') return i18n[key];
    return I18N_DEFAULTS[key] !== undefined ? I18N_DEFAULTS[key] : key;
  }

  // El CATÁLOGO no llama a t() (se carga antes que este archivo): declara claves
  // (labelKey/useCaseKey/unitKey) y conserva su castellano como respaldo. El
  // motor es quien resuelve.
  // ⚠️ Van por `tOr()` (definido más abajo, junto a las etiquetas de campo) y NO
  // por `t(clave) || gama.label`: `t()` devuelve el NOMBRE DE LA CLAVE cuando no
  // la encuentra, y al ser truthy el `||` NUNCA llegaba al respaldo del catálogo
  // ⇒ la tarjeta pintaba "gama_sintornillos_label" en crudo. Es el fallo de
  // `gama_bullrack_label` otra vez, y así queda cerrado para cualquier gama nueva
  // aunque su clave se olvide en I18N_DEFAULTS o en el Liquid.
  function gamaLabel(gama) { return gama ? tOr(gama.labelKey, gama.label || '') : ''; }
  function gamaUse(gama)   { return gama ? tOr(gama.useCaseKey, gama.description || '') : ''; }
  // { value, unitKey } (+ count/countUnitKey opcionales) → "1000 kg/palé · 6 palés".
  // Degrada en silencio si la gama todavía no declara capacity()/capacityMax().
  function formatCapacity(cap) {
    if (!cap || cap.value == null) return '';
    var out = cap.value + ' ' + t(cap.unitKey);
    if (cap.count != null && cap.countUnitKey) out += ' · ' + cap.count + ' ' + t(cap.countUnitKey);
    return out;
  }
  function gamaCapacityOf(gama, cfg) {
    if (!gama || typeof gama.capacity !== 'function') return '';
    try { return formatCapacity(gama.capacity(cfg)); } catch (e) { return ''; }
  }
  function gamaCapacityMax(gama) {
    if (!gama || typeof gama.capacityMax !== 'function') return '';
    var txt; try { txt = formatCapacity(gama.capacityMax()); } catch (e) { return ''; }
    return txt ? (t('cap_up_to') + ' ' + txt) : '';
  }

  var scene, renderer, perspCam, camera, controls, loader, raycaster;
  var roomGroup = null, floorMesh = null;
  var viewMode = 'orbit'; // 'orbit' | 'plan'

  // Convención de coordenadas de la SALA (mm, espacio propio — no mundo):
  //   x: 0..widthMM  (0 = pared izquierda)   z: 0..depthMM (0 = pared trasera)
  // Conversión a mundo (centrado en X, pared trasera en Z=0):
  //   worldX = (xMM - widthMM/2) * MM_TO_WORLD   worldZ = zMM * MM_TO_WORLD
  var room = { widthMM: 6000, depthMM: 4000, heightMM: 2700 };

  var items = [];       // { id, gamaId, cfg, xMM, zMM, rotationDeg, footprint, group, rawModel, overlap }
  var nextItemId = 1;
  var selectedItemId = null;
  var pendingLoads = 0;

  var activeGamaId = (window.SpaceCatalog && SpaceCatalog.order[0]) || null;
  var activeCfg = activeGamaId ? SpaceCatalog.GAMAS[activeGamaId].defaultConfig() : {};
  // ¿Ha elegido el usuario los niveles a mano? Lo necesita `bestHeightAndLevels` para
  // no pisar su elección. NO basta comparar con `defaultConfig()`: en RIVET el defecto
  // ya es 4 y en palés 2, así que "lo he puesto yo" y "no lo he tocado" serían
  // indistinguibles justo en los valores más habituales. Se pone a true en el
  // onChange del panel y se limpia al cambiar de gama (otra gama = otra intención).
  var nivelesTocados = false;

  var priceCache = {}; // key gamaId|JSON(cfg) → {price,compareAt,variantId,available,title}

  var _ptrDownX = 0, _ptrDownY = 0, dragCandidateId = null, isDragging = false, dragOffset = { x: 0, z: 0 };
  var _pointerDownOnCanvas = false; // el pointerup global solo debe (de)seleccionar si el gesto empezó en el canvas — si no, un clic en la toolbar/panel deselecciona antes de que su propio click llegue a disparar
  var editMode = false; // false = 'Mover vista' (orbitar), true = 'Editar' (arrastrar ítems)

  function getItem(id) { for (var i = 0; i < items.length; i++) if (items[i].id === id) return items[i]; return null; }

  // ─── Infra GLB compartida (caché por URL, clones con materiales propios) ───
  var glbSceneCache = {};
  function cloneScene(master) {
    var clone = master.clone(true);
    clone.traverse(function (child) {
      if (child.isMesh && child.material) {
        child.material = Array.isArray(child.material) ? child.material.map(function (m) { return m.clone(); }) : child.material.clone();
      }
    });
    return clone;
  }
  function loadCachedScene(url, onLoad, onError) {
    var entry = glbSceneCache[url];
    if (entry && entry.scene) { onLoad(cloneScene(entry.scene)); return; }
    if (entry && entry.pending) { entry.pending.push({ ok: onLoad, err: onError }); return; }
    glbSceneCache[url] = { scene: null, pending: [{ ok: onLoad, err: onError }] };
    loader.load(url, function (gltf) {
      var e = glbSceneCache[url]; e.scene = gltf.scene;
      var waiting = e.pending; e.pending = null;
      waiting.forEach(function (w) { w.ok(cloneScene(e.scene)); });
    }, undefined, function (err) {
      var e = glbSceneCache[url]; var waiting = (e && e.pending) || [];
      delete glbSceneCache[url];
      waiting.forEach(function (w) { if (w.err) w.err(err); });
    });
  }

  var kitCache = {}; // url → { index:{name:node}, pending:[] }
  function loadCachedKit(url, onLoad, onError) {
    var entry = kitCache[url];
    if (entry && entry.index) { onLoad(entry.index); return; }
    if (entry && entry.pending) { entry.pending.push({ ok: onLoad, err: onError }); return; }
    kitCache[url] = { index: null, pending: [{ ok: onLoad, err: onError }] };
    loader.load(url, function (gltf) {
      var idx = {};
      gltf.scene.traverse(function (obj) { if (obj.name) idx[obj.name] = obj; });
      var e = kitCache[url]; e.index = idx;
      var waiting = e.pending; e.pending = null;
      waiting.forEach(function (w) { w.ok(idx); });
    }, undefined, function (err) {
      var e = kitCache[url]; var waiting = (e && e.pending) || [];
      delete kitCache[url];
      waiting.forEach(function (w) { if (w.err) w.err(err); });
    });
  }

  function disposeGroupDeep(group) {
    group.traverse(function (child) {
      if (!child.isMesh) return;
      // Geometría compartida con la caché: no se destruye. Solo las marcadas
      // unitSpecific (recortes del 252 sintético) son propias de este ítem.
      if (child.geometry && child.geometry.userData && child.geometry.userData.unitSpecific) child.geometry.dispose();
      var mats = Array.isArray(child.material) ? child.material : [child.material];
      mats.forEach(function (m) { if (m) m.dispose(); });
    });
  }

  function visibleBox(model) {
    var box = new THREE.Box3();
    model.traverse(function (child) { if (child.isMesh && child.visible) box.union(new THREE.Box3().setFromObject(child)); });
    if (box.isEmpty()) box.setFromObject(model);
    return box;
  }

  function glbUrlsFor(gamaId) {
    var d = window.SpaceConfiguratorData;
    return (d && d.glbUrls && d.glbUrls[gamaId]) || {};
  }

  function beginLoad() { pendingLoads++; var el = document.getElementById('loading-overlay'); if (el) el.classList.remove('hidden'); }
  function endLoad() { pendingLoads = Math.max(0, pendingLoads - 1); if (pendingLoads === 0) { var el = document.getElementById('loading-overlay'); if (el) el.classList.add('hidden'); } }

  function showToast(msg) {
    var el = document.getElementById('sc-toast');
    if (!el) { el = document.createElement('div'); el.id = 'sc-toast'; document.body.appendChild(el); }
    el.textContent = msg; el.className = 'sc-toast sc-toast--visible';
    clearTimeout(el._t); el._t = setTimeout(function () { el.className = 'sc-toast'; }, 3200);
  }

  // ─── Ítems: creación, carga de modelo, colocación a escala real ───────────
  function addItem(gamaId, cfg, xMM, zMM, rotationDeg) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var item = {
      id: nextItemId++, gamaId: gamaId, cfg: Object.assign({}, cfg),
      xMM: xMM, zMM: zMM, rotationDeg: rotationDeg || 0,
      footprint: gama.footprintMM(cfg), group: null, rawModel: null, overlap: false
    };
    items.push(item);
    loadAndPlaceItem(item);
    return item;
  }

  function loadAndPlaceItem(item) {
    var gama = SpaceCatalog.GAMAS[item.gamaId];
    var urls = glbUrlsFor(item.gamaId);
    beginLoad();
    if (gama.loadMode === 'kit') {
      loadCachedKit(gama.kitUrl(urls), function (kitIndex) {
        var group = gama.assemble(kitIndex, item.cfg, THREE);
        finishPlaceItem(item, group); endLoad();
      }, function (err) { itemLoadError(item, err); endLoad(); });
    } else {
      var url = gama.resolveGlbUrl(item.cfg, urls);
      if (!url) { itemLoadError(item, new Error('no-glb-url')); endLoad(); return; }
      loadCachedScene(url, function (clone) {
        gama.applyVisibility(clone, item.cfg);
        gama.applyColor(clone, item.cfg);
        // Hook por gama para geometría derivada (p.ej. RIVET 252 sintético a
        // partir del GLB de 180) — ANTES de medir el bbox en finishPlaceItem.
        if (gama.postProcess) {
          try { gama.postProcess(clone, item.cfg, THREE); }
          catch (e) { console.error('[SpaceConfigurator] postProcess', item.gamaId, e); }
        }
        finishPlaceItem(item, clone); endLoad();
      }, function (err) { itemLoadError(item, err); endLoad(); });
    }
  }

  // Un modelo que no carga NUNCA deja un ítem fantasma: estaría en el resumen
  // (con precio) pero no en el visor — "los botones no hacen nada" (bug real
  // reportado con RIVET 252 sin GLB). Se retira el ítem entero y se avisa.
  function itemLoadError(item, err) {
    console.error('[SpaceConfigurator] Error cargando modelo', item.gamaId, err);
    var gama = SpaceCatalog.GAMAS[item.gamaId];
    if (item.group) { scene.remove(item.group); disposeGroupDeep(item.group); }
    items = items.filter(function (i) { return i.id !== item.id; });
    if (selectedItemId === item.id) deselectItem();
    refreshOverlapState(); renderItemsListUI(); redrawPlanIfActive();
    showToast(t('no_model').replace('{gama}', gamaLabel(gama) || item.gamaId));
  }

  // Centrado/escalado idéntico en espíritu a centerAndScaleUnit() de los
  // configuradores de producto: medir bbox real en fresh-load y escalar. La
  // diferencia es la referencia de escala: aquí es la altura FÍSICA REAL en
  // mm del footprint (MM_TO_WORLD), no una constante de mundo fija por gama —
  // así conviven en la misma sala productos de gamas con GLBs distintos.
  function finishPlaceItem(item, rawModel) {
    // ⚠️ El item pudo MORIR mientras su GLB bajaba: limpiar la sala (clearAllItems,
    // que dispara cualquier patrón de auto-relleno) o borrar la unidad lo saca de
    // `items[]`, pero NO cancela la descarga en vuelo — y `loadCachedScene` acumula
    // en el mismo array los callbacks de antes y después del borrado, así que se
    // resuelven todos juntos. Sin esta guarda el modelo se añadía a la escena
    // huérfano: visible pero imposible de seleccionar (el raycast solo mira
    // `items[]`), ausente del resumen/plano/PDF/carrito, y solo se iba recargando
    // la página. Se descarta el modelo y se sale sin tocar la escena.
    if (items.indexOf(item) === -1) { disposeGroupDeep(rawModel); return; }
    if (item.group) { scene.remove(item.group); disposeGroupDeep(item.group); }
    rawModel.scale.set(1, 1, 1); rawModel.position.set(0, 0, 0); rawModel.rotation.set(0, 0, 0);
    rawModel.updateMatrixWorld(true);
    var box = visibleBox(rawModel);
    var size = box.getSize(new THREE.Vector3());
    var center = box.getCenter(new THREE.Vector3());
    var scale = (item.footprint.height * MM_TO_WORLD) / (size.y || 1);
    // Traslación en las MISMAS unidades finales que el escalado (T*S, no S*T):
    // la posición debe darse ya multiplicada por scale, igual que hacen los
    // configuradores de producto (ver centerAndScaleUnit: "xOffset - center.x*scale").
    rawModel.position.set(-center.x * scale, -box.min.y * scale, -center.z * scale);
    rawModel.scale.setScalar(scale);
    rawModel.traverse(function (c) { if (c.isMesh) { c.castShadow = false; c.receiveShadow = false; } });

    var group = new THREE.Group();
    group.add(rawModel);
    group.userData.spaceItemId = item.id;
    item.group = group; item.rawModel = rawModel;
    scene.add(group);
    positionItemGroup(item);
    refreshOverlapState();
    renderItemsListUI();
  }

  function positionItemGroup(item) {
    if (!item.group) return;
    item.group.position.set((item.xMM - room.widthMM / 2) * MM_TO_WORLD, 0, item.zMM * MM_TO_WORLD);
    item.group.rotation.y = (item.rotationDeg || 0) * Math.PI / 180;
  }

  function findItemIdFromObject(obj) {
    var o = obj;
    while (o) { if (o.userData && o.userData.spaceItemId != null) return o.userData.spaceItemId; o = o.parent; }
    return null;
  }

  // ─── Footprint / solapes ────────────────────────────────────────────────────
  function itemFootprintWD(item) {
    var fp = item.footprint;
    var rotated = Math.abs(item.rotationDeg % 180) === 90;
    return { w: rotated ? fp.depth : fp.width, d: rotated ? fp.width : fp.depth };
  }
  // ÚNICA fórmula del rectángulo de huella en coordenadas de sala. La usan tanto
  // los ítems reales (itemRectMM) como el sumidero de simulación (makeDrySink):
  // si divergieran, la puntuación de la "distribución óptima" mediría una
  // geometría distinta de la que acaba en la escena, y dejaría de ser fiable.
  // A 90/270° el footprint gira: ancho y fondo se intercambian.
  function rectFromFootprint(fp, xMM, zMM, rotDeg) {
    var rotated = Math.abs((rotDeg || 0) % 180) === 90;
    var w = rotated ? fp.depth : fp.width;
    var d = rotated ? fp.width : fp.depth;
    return { x0: xMM - w / 2, x1: xMM + w / 2, z0: zMM - d / 2, z1: zMM + d / 2 };
  }
  function itemRectMM(item) {
    return rectFromFootprint(item.footprint, item.xMM, item.zMM, item.rotationDeg);
  }
  function rectsOverlap(a, b) { return a.x0 < b.x1 - 1 && a.x1 > b.x0 + 1 && a.z0 < b.z1 - 1 && a.z1 > b.z0 + 1; }
  // Nunca se recorta un producto a la altura de la sala (su altura física real
  // es la verdad) — si la supera, solo se avisa (mismo tinte que un solape).
  function itemOutOfRoom(item) {
    var r = itemRectMM(item);
    return r.x0 < -0.5 || r.z0 < -0.5 || r.x1 > room.widthMM + 0.5 || r.z1 > room.depthMM + 0.5 ||
      item.footprint.height > room.heightMM + 0.5;
  }
  function refreshOverlapState() {
    items.forEach(function (a) { a.overlap = itemOutOfRoom(a); });
    for (var i = 0; i < items.length; i++) {
      for (var j = i + 1; j < items.length; j++) {
        if (rectsOverlap(itemRectMM(items[i]), itemRectMM(items[j]))) { items[i].overlap = true; items[j].overlap = true; }
      }
    }
    items.forEach(applyItemTint);
  }
  function applyItemTint(item) {
    if (!item.rawModel) return;
    var tint = item.overlap ? 0xFF4D4D : null;
    item.rawModel.traverse(function (c) {
      if (!c.isMesh || !c.material) return;
      var mats = Array.isArray(c.material) ? c.material : [c.material];
      mats.forEach(function (m) {
        if (!m.emissive) return;
        if (tint != null) { m.emissive.setHex(tint); m.emissiveIntensity = 0.4; }
        else { m.emissive.setHex(0x000000); m.emissiveIntensity = 0; }
      });
    });
  }

  function clearAllItems() {
    items.forEach(function (it) { if (it.group) { scene.remove(it.group); disposeGroupDeep(it.group); } });
    items = [];
    selectedItemId = null;
    var tb = document.getElementById('item-toolbar'); if (tb) tb.style.display = 'none';
  }

  // ─── Simulación de un auto-relleno (sin escena, sin GLB) ───────────────────
  // Sumidero de simulación: mismo contrato que addItem() pero sin escena ni GLB.
  // Permite puntuar una distribución completa sin descargar un solo modelo — es
  // lo que hace viable comparar 16 candidatas antes de aplicar una (addItem es
  // asíncrono: carga GLB, mide bbox y toca el DOM, así que evaluar de verdad
  // cada candidata costaría decenas de descargas y un parpadeo de la sala).
  // `capacityMM` es la puntuación: metros lineales de balda en mm, es decir
  // Σ (ancho real de la unidad × sus niveles).
  // Longitud de BALDA de una unidad, que NO es su huella. En las gamas con
  // módulos encadenados, la huella de una Extensión descuenta el bastidor que
  // comparte con su vecino (Media Carga: −111 mm) porque es una medida de
  // OCUPACIÓN en planta; pero la balda es la MISMA pieza física que en un
  // Inicial, así que su longitud no cambia. Puntuar por huella infravaloraba
  // Media Carga un 5,5 % y en algunas salas llegaba a cambiar el patrón ganador.
  // El nombre del valor "inicial" se lee del propio catálogo (options[0] del
  // campo unitType), para no cablear aquí el vocabulario de ninguna gama.
  function shelfWidthMM(gama, cfg) {
    var fpW = gama.footprintMM(cfg).width;
    if (!cfg.unitType || !gama.fields) return fpW;
    for (var i = 0; i < gama.fields.length; i++) {
      var f = gama.fields[i];
      if (f.key !== 'unitType' || !f.options || !f.options.length) continue;
      if (cfg.unitType === f.options[0]) return fpW; // ya es el módulo completo
      var asFull = Object.assign({}, cfg);
      asFull.unitType = f.options[0];
      return gama.footprintMM(asFull).width;
    }
    return fpW;
  }

  function makeDrySink() {
    var out = { rects: [], units: [], capacityMM: 0 };
    out.place = function (gamaId, cfg, xMM, zMM, rotDeg) {
      var gama = SpaceCatalog.GAMAS[gamaId];
      if (!gama) return null;
      var fp = gama.footprintMM(cfg);
      var niveles = parseInt(cfg.niveles, 10) || 0;
      var rec = {
        gamaId: gamaId, cfg: cfg, xMM: xMM, zMM: zMM, rotationDeg: rotDeg || 0,
        footprint: fp, niveles: niveles
      };
      out.units.push(rec);
      out.rects.push(rectFromFootprint(fp, xMM, zMM, rotDeg));
      out.capacityMM += shelfWidthMM(gama, cfg) * niveles;
      return rec;
    };
    return out;
  }
  // Presupuesto GLOBAL de unidades reales. Cada unidad es un clon de GLB en la
  // escena, así que el tope existe para no tumbar el navegador. Antes vivía como
  // un `CAP = 300` local dentro de autoFillRows y autoFillIslands: perímetro NO
  // tenía tope y perímetro+islas no propagaba el del perímetro, así que en salas
  // grandes se colocaban 370-696 unidades y el usuario no veía ningún aviso.
  // Aquí se aplica en el ÚNICO punto por el que pasan los 4 patrones.
  // La SIMULACIÓN no se capa a propósito: la puntuación debe reflejar lo que de
  // verdad cabe. Efecto secundario aceptado: en una sala enorme puede ganar un
  // patrón cuya capacidad completa no se llega a colocar — pero se avisa con
  // "límite alcanzado", que es justo lo que antes faltaba.
  var MAX_ITEMS_TOTAL = 300;
  var _budgetHit = false;

  // Un `sink` presente = simulación; ausente = colocación real. Es el ÚNICO
  // punto donde se bifurca: los 4 patrones no saben en qué modo corren.
  function placeUnit(sink, gamaId, cfg, xMM, zMM, rotDeg) {
    if (sink) return sink.place(gamaId, cfg, xMM, zMM, rotDeg);
    if (items.length >= MAX_ITEMS_TOTAL) { _budgetHit = true; return null; }
    return addItem(gamaId, cfg, xMM, zMM, rotDeg);
  }

  // ─── Auto-relleno ───────────────────────────────────────────────────────────
  // Principio común a los 4 patrones: el FRENTE de una estantería (la cara
  // accesible, por convención la que el GLB modela mirando a +Z sin rotar)
  // SIEMPRE debe quedar mirando a un pasillo — nunca contra una pared ni contra
  // el lateral de la estantería de al lado. "stackAxis" fija en qué eje se
  // apilan las FILAS (con pasillo entre ellas): 'z' = filas corren a lo ancho
  // (eje X) y se apilan en profundidad (eje Z, rotación 0°); 'x' = filas corren
  // a lo largo (eje Z) y se apilan en anchura (eje X, rotación 90° para que el
  // frente, que rota con la pieza, siga mirando al pasillo que ahora está en X).
  // Dentro de un tramo contiguo (una fila, un lado de perímetro...) el PRIMER módulo
  // de una gama con cadena lleva sus dos bastidores y el resto comparten el del
  // anterior — un run real, igual que en el configurador de producto.
  //
  // ⚠️ Esto lo declara el CATÁLOGO (`gama.chain`), no el motor. Antes estaba cableado
  // a 'mediaCarga', así que al añadir la gama de palés —que tiene la misma mecánica de
  // Inicial/Adicional— sus filas salían con TODOS los módulos como Inicial: cada uno
  // con sus dos bastidores, ~25% más caro y con 10 mm de hueco donde deberían compartir
  // el puntal. El motor no vuelve a nombrar gamas.
  function chainOf(gamaId) {
    var g = SpaceCatalog.GAMAS[gamaId];
    return (g && g.chain) || null;
  }
  function cfgForRunIndex(gamaId, cfgTemplate, indexInRun) {
    var ch = chainOf(gamaId);
    if (!ch) return cfgTemplate;
    var c = Object.assign({}, cfgTemplate);
    c.unitType = indexInRun === 0 ? ch.full : ch.shared;
    return c;
  }
  function placeRowUnit(gamaId, cfg, stackAxis, posAlong, posAcross, rotDeg, sink) {
    return (stackAxis === 'x')
      ? placeUnit(sink, gamaId, cfg, posAcross, posAlong, rotDeg)   // across=X, along=Z
      : placeUnit(sink, gamaId, cfg, posAlong, posAcross, rotDeg);  // along=X, across=Z (por defecto)
  }

  // En un run de Media Carga el Inicial debe quedar en el extremo hacia el que
  // apunta el lado ABIERTO de las Extensiones (cada extensión encadena con su
  // vecino anterior). packRun empaqueta con el Inicial en el índice 0; si tras
  // rotar el lado abierto apunta EN el sentido de avance del run (p.ej. filas a
  // 180°: espalda-con-espalda, pared frontal del perímetro), se ESPEJA el run
  // completo para que el Inicial acabe en el extremo lejano. En las demás gamas
  // el espejado es geométricamente inocuo (anchos uniformes).
  function chainOffset(run, unit, rotationDeg, advanceAxis) {
    var dir = openSideDir(rotationDeg);
    var comp = (advanceAxis === 'x') ? dir.x : dir.z;
    return comp > 0.5 ? (run.usedLen - unit.offset) : unit.offset;
  }
  function axisLengths(stackAxis) {
    return (stackAxis === 'x')
      ? { along: room.depthMM, across: room.widthMM }
      : { along: room.widthMM, across: room.depthMM };
  }

  // Separación lateral mínima entre productos (petición explícita: ~1cm), EXCEPTO en
  // las gamas con cadena, cuyos módulos se tocan porque comparten bastidor. Lo declara
  // el catálogo (`chain.sideGapMM`), no una lista de gamas en el motor.
  var SIDE_GAP_MM = 10;
  function sideGapFor(gamaId) {
    var ch = chainOf(gamaId);
    return (ch && typeof ch.sideGapMM === 'number') ? ch.sideGapMM : SIDE_GAP_MM;
  }

  // Empaqueta un tramo contiguo acumulando el ANCHO REAL de cada posición (no
  // una rejilla fija): imprescindible para Media Carga, donde una Extensión es
  // más estrecha que una Inicial (comparte bastidor) — el resto de gamas tienen
  // ancho uniforme y esto se reduce al reparto de siempre.
  var MAX_UNITS_PER_RUN = 500;
  function packRun(gamaId, cfgTemplate, availableLen) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var gap = sideGapFor(gamaId);
    var units = [], cursor = 0, i = 0;
    while (i < MAX_UNITS_PER_RUN) {
      var cfg = cfgForRunIndex(gamaId, cfgTemplate, i);
      var w = gama.footprintMM(cfg).width;
      if (cursor + w > availableLen) break;
      units.push({ cfg: cfg, width: w, offset: cursor + w / 2 });
      cursor += w + gap; i++;
    }
    return { units: units, usedLen: units.length ? (cursor - gap) : 0 };
  }
  function runSumWidths(run) {
    var s = 0; for (var i = 0; i < run.units.length; i++) s += run.units[i].width; return s;
  }

  // ─── Reparto óptimo del tramo (mezcla de anchuras) ─────────────────────────
  // Anchuras candidatas: se DEDUCEN del catálogo, nunca se hardcodean. Se prueba
  // cada campo con `options` sobre `defaultConfig()` y se queda el que, al variar,
  // mueve SOLO el ancho del footprint (ni fondo ni alto) y cuyas opciones son
  // numéricas (cm). Eso identifica `anchura` en RIVET/Versatile y `ancho` en
  // Media Carga sin saber sus nombres, y descarta a la vez: alto/fondo (mueven
  // otra dimensión), niveles (dinámico, sin options), color/tipoBalda (no tocan
  // la huella) y el `unitType` de Media Carga — que también estrecha el ancho,
  // pero sus opciones no son numéricas y además NO es un eje de reparto: lo fija
  // la cadena del run (índice 0 = Inicial, resto = Extensión).
  var _widthFieldCache = {};
  function widthFieldOf(gamaId) {
    if (Object.prototype.hasOwnProperty.call(_widthFieldCache, gamaId)) return _widthFieldCache[gamaId];
    var gama = SpaceCatalog.GAMAS[gamaId];
    var found = null;
    if (gama && gama.fields && typeof gama.defaultConfig === 'function' && typeof gama.footprintMM === 'function') {
      var base = gama.defaultConfig();
      var baseFp = null;
      try { baseFp = gama.footprintMM(base); } catch (e) { baseFp = null; }
      for (var i = 0; baseFp && i < gama.fields.length && !found; i++) {
        var f = gama.fields[i];
        if (!f || f.dynamic || !f.options || f.options.length < 2) continue;
        var allNumeric = true, movesWidth = false, movesOther = false;
        for (var j = 0; j < f.options.length; j++) {
          if (!isFinite(parseFloat(f.options[j]))) { allNumeric = false; break; }
          var probe = Object.assign({}, base);
          probe[f.key] = f.options[j];
          var fp = null;
          try { fp = gama.footprintMM(probe); } catch (e2) { fp = null; }
          if (!fp) continue;
          if (fp.width !== baseFp.width) movesWidth = true;
          if (fp.depth !== baseFp.depth || fp.height !== baseFp.height) movesOther = true;
        }
        if (allNumeric && movesWidth && !movesOther) found = f;
      }
    }
    _widthFieldCache[gamaId] = found;
    return found;
  }

  // ─── Encaje del producto en el ALTO de tu espacio ──────────────────────────
  // Hasta ahora nada comprobaba el alto: un bastidor de palés mide 3-6 m y la
  // sala por defecto 2,70, así que se colocaba atravesando el techo. Igual que
  // con la anchura, el campo de altura se DEDUCE (unas gamas lo llaman `altura`
  // y otras `alto`): es el único cuyas opciones mueven footprintMM().height.
  var _heightFieldCache = {};
  function heightFieldOf(gamaId) {
    if (Object.prototype.hasOwnProperty.call(_heightFieldCache, gamaId)) return _heightFieldCache[gamaId];
    var gama = SpaceCatalog.GAMAS[gamaId];
    var found = null;
    if (gama && gama.fields && typeof gama.defaultConfig === 'function' && typeof gama.footprintMM === 'function') {
      var base = gama.defaultConfig();
      var baseFp = null;
      try { baseFp = gama.footprintMM(base); } catch (e) { baseFp = null; }
      for (var i = 0; baseFp && i < gama.fields.length && !found; i++) {
        var f = gama.fields[i];
        // Aquí NO se exige options.length >= 2 (a diferencia de la anchura): BULLRACK
        // tiene una sola altura ('200') y aun así hay que saber que ese es su campo
        // de alto para poder avisar de que no cabe.
        if (!f || f.dynamic || !f.options || !f.options.length) continue;
        var movesHeight = false;
        for (var j = 0; j < f.options.length; j++) {
          var probe = Object.assign({}, base);
          probe[f.key] = f.options[j];
          var fp = null;
          try { fp = gama.footprintMM(probe); } catch (e2) { fp = null; }
          if (fp && fp.height !== baseFp.height) movesHeight = true;
        }
        // Con una sola opción no hay forma de detectar movimiento: se acepta si su
        // valor numérico casa con la altura del footprint en cm (200 → 2000 mm).
        if (!movesHeight && f.options.length === 1) {
          var v = parseFloat(f.options[0]);
          movesHeight = isFinite(v) && Math.abs(v * 10 - baseFp.height) < 60;
        }
        if (movesHeight) found = f;
      }
    }
    _heightFieldCache[gamaId] = found;
    return found;
  }

  // Pasillo mínimo recomendado por gama. Una carretilla elevadora necesita ~2,8 m
  // de pasillo, no los 90 cm que valen para picking a mano: con el pasillo por
  // defecto, una distribución de palés es física pero operativamente inservible.
  // La gama puede declararlo (`minAisleMM`); si no, se asume el de picking.
  var DEFAULT_MIN_AISLE_MM = 900;
  function minAisleFor(gamaId) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var v = gama && parseInt(gama.minAisleMM, 10);
    return (v && v > 0) ? v : DEFAULT_MIN_AISLE_MM;
  }

  // Al elegir una gama: baja la altura a una que quepa (y avisa si NINGUNA cabe),
  // y sube el pasillo del panel si esa gama necesita más. Se avisa siempre que se
  // toca algo — un cambio silencioso de los valores que el usuario ve es peor que
  // no cambiarlos.
  function adaptCfgToRoom(gamaId) {
    var avisos = [];
    if (!cfgFitsRoomHeight(gamaId, activeCfg)) {
      var fix = lowestFittingHeight(gamaId);
      if (fix) {
        activeCfg[fix.key] = fix.value;
        var validN = SpaceCatalog.GAMAS[gamaId].nivelesFor(activeCfg).map(String);
        if (validN.indexOf(String(activeCfg.niveles)) === -1) activeCfg.niveles = parseInt(validN[0], 10);
      } else {
        avisos.push(t('fit_ninguna_altura').replace('{sala}', Math.round(room.heightMM / 10)));
      }
    }
    var min = minAisleFor(gamaId);
    var aisleEl = document.getElementById('opt-aisle');
    if (aisleEl) {
      var actual = (parseFloat(aisleEl.value) || 90) * 10;
      if (actual < min) {
        aisleEl.value = String(Math.round(min / 10));
        avisos.push(t('fit_pasillo').replace('{n}', Math.round(min / 10)));
      }
    }
    if (avisos.length) showToast(avisos.join(' '));
    return avisos.length === 0;
  }

  // Alto real (mm) que tendría la gama con ese valor del campo de altura.
  function heightForOption(gamaId, field, optionValue, cfg) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var probe = Object.assign({}, cfg || gama.defaultConfig());
    probe[field.key] = optionValue;
    try { return gama.footprintMM(probe).height; } catch (e) { return 0; }
  }
  function cfgFitsRoomHeight(gamaId, cfg) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    if (!gama || typeof gama.footprintMM !== 'function') return true;
    try { return gama.footprintMM(cfg).height <= room.heightMM + 1; } catch (e) { return true; }
  }
  // ¿Cabe ALGUNA medida de esta gama en el alto de la sala?
  function gamaFitsRoomHeight(gamaId) {
    var field = heightFieldOf(gamaId);
    if (!field) return cfgFitsRoomHeight(gamaId, SpaceCatalog.GAMAS[gamaId].defaultConfig());
    var base = SpaceCatalog.GAMAS[gamaId].defaultConfig();
    for (var i = 0; i < field.options.length; i++) {
      if (heightForOption(gamaId, field, field.options[i], base) <= room.heightMM + 1) return true;
    }
    return false;
  }
  // La opción de altura más baja que sí cabe (para reencajar la config al vuelo).
  function lowestFittingHeight(gamaId) {
    var field = heightFieldOf(gamaId);
    if (!field) return null;
    var base = SpaceCatalog.GAMAS[gamaId].defaultConfig();
    var best = null, bestH = Infinity;
    for (var i = 0; i < field.options.length; i++) {
      var h = heightForOption(gamaId, field, field.options[i], base);
      if (h <= room.heightMM + 1 && h < bestH) { bestH = h; best = field.options[i]; }
    }
    return best ? { key: field.key, value: best } : null;
  }

  // Reparte un tramo mezclando las anchuras que la gama declara en fields[],
  // maximizando el ancho útil colocado (y a igualdad, con MENOS módulos: menos
  // uniones y más baratos). packRun() usaba una sola anchura y desperdiciaba el
  // sobrante del tramo (p.ej. un tramo de 5,94 m con módulos de 1,2 m dejaba
  // 1,1 m muertos que sí admiten un módulo de 0,9 m).
  //
  // DP exacto sobre una rejilla de 10 mm: `best[s]` = mejor secuencia cuyo coste
  // cuantizado son exactamente `s` pasos. El coste de cada módulo se redondea
  // HACIA ARRIBA, así que el reparto devuelto nunca excede el tramo real (los
  // anchos de Extensión de Media Carga no son múltiplos de 10: 1850−111=1739).
  // El objetivo (ancho, −nº módulos) es aditivo y lexicográfico ⇒ basta guardar
  // el mejor estado por longitud, sin perder el óptimo global.
  var PACK_STEP_MM = 10;
  function packRunOptimized(gamaId, cfgTemplate, availableLen) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var uniform = packRun(gamaId, cfgTemplate, availableLen);
    var field = widthFieldOf(gamaId);
    if (!gama || !field || !(availableLen > 0)) return uniform;

    var gap = sideGapFor(gamaId);
    var i, s, c;
    // Por cada anchura del catálogo, su huella como PRIMER módulo del run
    // (Inicial en Media Carga) y como módulo posterior (Extensión, más estrecha).
    var cands = [];
    for (i = 0; i < field.options.length; i++) {
      var base = Object.assign({}, cfgTemplate);
      base[field.key] = field.options[i];
      var cfg0 = cfgForRunIndex(gamaId, base, 0), cfgN = cfgForRunIndex(gamaId, base, 1);
      var w0, wN;
      try { w0 = gama.footprintMM(cfg0).width; wN = gama.footprintMM(cfgN).width; } catch (e) { continue; }
      if (!(w0 > 0) || !(wN > 0)) continue;
      cands.push({ cfg0: cfg0, w0: w0, cfgN: cfgN, wN: wN });
    }
    if (!cands.length) return uniform;

    function stepsOf(mmv) { return Math.ceil(mmv / PACK_STEP_MM); }
    function betterPack(a, b) {
      if (!b) return true;
      if (a.sum !== b.sum) return a.sum > b.sum;   // más ancho útil manda
      return a.count < b.count;                     // a igualdad, menos módulos
    }

    var L = Math.floor(availableLen / PACK_STEP_MM);
    var best = [];
    for (c = 0; c < cands.length; c++) {            // semillas: primer módulo del run
      var cost0 = stepsOf(cands[c].w0);
      if (cost0 > L) continue;
      var seed = { sum: cands[c].w0, count: 1, prev: -1, w: cands[c].w0, cfg: cands[c].cfg0 };
      if (betterPack(seed, best[cost0])) best[cost0] = seed;
    }
    for (s = 1; s <= L; s++) {
      var cur = best[s];
      if (!cur || cur.count >= MAX_UNITS_PER_RUN) continue;
      for (c = 0; c < cands.length; c++) {
        var s2 = s + stepsOf(gap + cands[c].wN);     // el gap va ENTRE módulos, no tras el último
        if (s2 > L) continue;
        var nxt = { sum: cur.sum + cands[c].wN, count: cur.count + 1, prev: s, w: cands[c].wN, cfg: cands[c].cfgN };
        if (betterPack(nxt, best[s2])) best[s2] = nxt;
      }
    }

    var bs = -1;
    for (s = 0; s <= L; s++) if (best[s] && (bs < 0 || betterPack(best[s], best[bs]))) bs = s;
    if (bs < 0) return uniform;                      // no cabe ni un módulo (uniform también está vacío)

    var seq = [], node = best[bs];
    while (node) {
      seq.push({ cfg: node.cfg, width: node.w });
      node = node.prev < 0 ? null : best[node.prev];
    }
    seq.reverse();                                   // el walk hacia atrás acaba en la semilla = índice 0 del run

    var units = [], cursor = 0;
    for (i = 0; i < seq.length; i++) {
      units.push({ cfg: seq[i].cfg, width: seq[i].width, offset: cursor + seq[i].width / 2 });
      cursor += seq[i].width + gap;
    }
    var out = { units: units, usedLen: units.length ? (cursor - gap) : 0 };

    // Red de seguridad del redondeo: la cuantización a 10 mm es CONSERVADORA
    // (ceil por módulo), así que en teoría podría dejar fuera un reparto uniforme
    // que cabía por 1-2 mm. Si eso pasa, se devuelve el uniforme — así "nunca
    // peor que packRun" es una garantía dura, no una observación empírica.
    if (out.usedLen > availableLen + 0.5) return uniform;
    if (runSumWidths(uniform) > runSumWidths(out) || uniform.usedLen > out.usedLen) return uniform;
    return out;
  }

  // Los 4 patrones empaquetan con el reparto uniforme de siempre salvo que se
  // pida explícitamente el óptimo (`opts.optimizePack`, que solo activa el botón
  // "Distribución óptima") — así la simulación y la aplicación real del ganador
  // usan EXACTAMENTE el mismo reparto, y los 4 botones clásicos no cambian.
  function packRunFor(opts, gamaId, cfgTemplate, availableLen) {
    return (opts && opts.optimizePack)
      ? packRunOptimized(gamaId, cfgTemplate, availableLen)
      : packRun(gamaId, cfgTemplate, availableLen);
  }

  // Patrón 1: filas paralelas con pasillo regular entre ellas.
  //
  // Sin backToBack: filas simples uniformes desde el margen, cada una con el
  // frente mirando siempre hacia +across (rotationDeg) — comportamiento previo
  // intacto.
  //
  // Con backToBack: esquema de almacén real single–pairs–single (no pares
  // uniformes desde la pared, que dejaban frentes tapados por la pared o por
  // el módulo vecino): una fila SIMPLE de espaldas contra la pared de inicio,
  // tantos PARES espalda-con-espalda como quepan con pasillo a cada lado, y
  // (si el hueco restante lo permite) una fila SIMPLE final de espaldas contra
  // la pared opuesta.
  function autoFillRows(gamaId, cfgTemplate, opts, sink) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var fp = gama.footprintMM(cfgTemplate);
    var aisleMM = opts.aisleMM || 900;
    var backToBack = !!opts.backToBack;
    var stackAxis = opts.stackAxis === 'x' ? 'x' : 'z';
    var rotationDeg = stackAxis === 'x' ? 90 : 0;
    var marginMM = 30;
    var lens = axisLengths(stackAxis);
    var unitAcross = fp.depth;

    var run = packRunFor(opts, gamaId, cfgTemplate, lens.along - marginMM * 2);
    if (!run.units.length) return { placed: 0, rows: 0, reason: 'no-fit' };

    var rowsPlaced = 0, placed = 0, CAP = 300, capped = false;
    var advanceAxis = (stackAxis === 'x') ? 'z' : 'x';
    var rotBack = (rotationDeg + 180) % 360;

    function placeRow(centerAcross, rotDeg) {
      for (var i = 0; i < run.units.length; i++) {
        if (placed >= CAP) { capped = true; return; }
        var posAlong = marginMM + chainOffset(run, run.units[i], rotDeg, advanceAxis);
        placeRowUnit(gamaId, run.units[i].cfg, stackAxis, posAlong, centerAcross, rotDeg, sink);
        placed++;
      }
    }

    if (!backToBack) {
      var cursorAcross = marginMM;
      while (cursorAcross + unitAcross <= lens.across - marginMM) {
        placeRow(cursorAcross + unitAcross / 2, rotationDeg);
        if (capped) break;
        rowsPlaced++;
        cursorAcross += unitAcross + aisleMM;
      }
      if (!sink) { refreshOverlapState(); refreshPricesAndTotals(); }
      return { placed: placed, rows: rowsPlaced, perRow: run.units.length, capped: capped };
    }

    // Caso degenerado: ni la fila inicial (espalda a la pared de inicio) cabe.
    if (2 * marginMM + unitAcross > lens.across) return { placed: 0, rows: 0, reason: 'no-fit' };

    // 1) Fila SIMPLE inicial — espalda a la pared de inicio, frente hacia +across.
    placeRow(marginMM + unitAcross / 2, rotationDeg);
    rowsPlaced++;
    var cursor = marginMM + unitAcross + aisleMM;

    // 2) Pares espalda-con-espalda mientras quepan con pasillo a ambos lados.
    if (!capped) {
      while (cursor + 2 * unitAcross <= lens.across - marginMM) {
        placeRow(cursor + unitAcross / 2, rotBack);        // p1: frente al pasillo anterior
        if (capped) break;
        placeRow(cursor + unitAcross * 1.5, rotationDeg);  // p2: frente al pasillo siguiente
        if (capped) break;
        rowsPlaced++;
        cursor += 2 * unitAcross + aisleMM;
      }
    }

    // 3) Fila SIMPLE final — espalda a la pared opuesta, frente hacia el
    // pasillo anterior (rotBack) — solo si queda pasillo completo hasta lo
    // último colocado. OJO: "cursor" YA incluye el aisleMM reservado tras la
    // fila/par anterior — exigir otro aisleMM encima duplicaba el pasillo
    // real requerido (bug real, encontrado por verificación adversaria: hasta
    // 23% de anchos de sala perdían una fila que sí cabía). El criterio
    // correcto es que el borde cercano de la fila final llegue, como mínimo,
    // a donde ya empieza el hueco reservado (cursor) — no más allá.
    if (!capped) {
      var finalCenter = lens.across - marginMM - unitAcross / 2;
      var finalNearEdge = lens.across - marginMM - unitAcross;
      if (finalNearEdge >= cursor) {
        placeRow(finalCenter, rotBack);
        if (!capped) rowsPlaced++;
      }
    }

    if (!sink) { refreshOverlapState(); refreshPricesAndTotals(); }
    return { placed: placed, rows: rowsPlaced, perRow: run.units.length, capped: capped };
  }

  // Patrón 2: perímetro — estanterías contra las 4 paredes, frente al centro.
  // No limpia items por sí sola: lo hace SIEMPRE el despachador autoFill().
  function autoFillPerimeter(gamaId, cfgTemplate, opts, sink) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var fp = gama.footprintMM(cfgTemplate);
    var marginMM = 30;
    var placed = 0;

    // cornerInset (no solo marginMM) en AMBOS extremos del eje "along": deja
    // hueco para que la pared perpendicular no se solape en la esquina (su
    // grosor hacia dentro de la sala es fp.depth, igual en las 4 paredes).
    function wallRun(alongLen, acrossFixed, rotDeg, advanceAxis, mapToXZ) {
      var cornerInset = fp.depth + marginMM;
      var run = packRunFor(opts, gamaId, cfgTemplate, alongLen - cornerInset * 2);
      run.units.forEach(function (u) {
        var xz = mapToXZ(cornerInset + chainOffset(run, u, rotDeg, advanceAxis), acrossFixed);
        placeUnit(sink, gamaId, u.cfg, xz.x, xz.z, rotDeg);
        placed++;
      });
      return run.units.length;
    }
    // Pared trasera (z≈0), frente hacia +Z. Deja hueco en las esquinas para las paredes laterales.
    wallRun(room.widthMM, fp.depth / 2 + marginMM, 0, 'x', function (along, across) { return { x: along, z: across }; });
    // Pared frontal (z≈depthMM), frente hacia -Z.
    wallRun(room.widthMM, room.depthMM - fp.depth / 2 - marginMM, 180, 'x', function (along, across) { return { x: along, z: across }; });
    // Pared izquierda (x≈0), frente hacia +X.
    wallRun(room.depthMM, fp.depth / 2 + marginMM, 90, 'z', function (along, across) { return { x: across, z: along }; });
    // Pared derecha (x≈widthMM), frente hacia -X.
    wallRun(room.depthMM, room.widthMM - fp.depth / 2 - marginMM, 270, 'z', function (along, across) { return { x: across, z: along }; });

    if (!sink) { refreshOverlapState(); refreshPricesAndTotals(); }
    return { placed: placed, rows: 4, reason: placed ? null : 'no-fit' };
  }

  // Patrón 3: islas espalda-con-espalda, CENTRADAS con pasillo en los 4 lados.
  // Las filas SIEMPRE se apilan hacia la pared MÁS LARGA. edgeGap distingue
  // el origen de la llamada: si viene con bounds (desde perímetro+islas) el
  // pasillo ya se descontó al calcular esos bounds, así que aquí solo hace
  // falta el margen mínimo a los límites recibidos; si se llama a sala completa
  // (patrón "islands" puro) hay que dejar el pasillo completo también contra
  // las paredes reales.
  function autoFillIslands(gamaId, cfgTemplate, opts, bounds, sink) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var fp = gama.footprintMM(cfgTemplate);
    var aisleMM = opts.aisleMM || 900;
    var marginMM = 30;
    // ⚠️ DOS holguras distintas, y confundirlas fue un bug real (palés, ago-2026):
    //   · edgeGap (eje ACROSS, el que apila filas): la cara exterior de la isla de
    //     los extremos mira a la pared y desde ahí se pica, así que ahí SÍ hace
    //     falta pasillo completo. Con `bounds` ya viene descontado por el llamante.
    //   · endGap (eje ALONG, el largo de la fila): los extremos de la fila dan a
    //     las paredes laterales y NADIE opera desde ahí — basta el margen, igual
    //     que en autoFillRows (que usa marginMM). Usar el pasillo aquí tiraba
    //     2×pasillo de largo de fila: con palés (2,8 m) son 5,6 m por fila, y en
    //     un espacio de 6 m de ancho dejaba 400 mm → CERO módulos y un "no cabe"
    //     con sitio de sobra. En perímetro+islas no se notaba porque allí llega
    //     con `bounds` y entonces edgeGap ya valía marginMM.
    var edgeGap = bounds ? marginMM : aisleMM;
    var endGap = marginMM;
    var b = bounds || { x0: 0, x1: room.widthMM, z0: 0, z1: room.depthMM };
    var boundsW = b.x1 - b.x0, boundsD = b.z1 - b.z0;
    var stackAxis = boundsW >= boundsD ? 'z' : 'x';
    var rotationDeg = stackAxis === 'x' ? 90 : 0;
    var lens = stackAxis === 'x' ? { along: boundsD, across: boundsW } : { along: boundsW, across: boundsD };
    var unitAcross = fp.depth;

    var nRows = Math.floor((lens.across - 2 * edgeGap + aisleMM) / (2 * unitAcross + aisleMM));
    if (nRows < 1) return { placed: 0, rows: 0, reason: 'no-fit' };

    var run = packRunFor(opts, gamaId, cfgTemplate, lens.along - 2 * endGap);
    if (!run.units.length) return { placed: 0, rows: 0, reason: 'no-fit' };

    var totalAcross = nRows * 2 * unitAcross + (nRows - 1) * aisleMM;
    var startAcross = (lens.across - totalAcross) / 2;
    var startAlong = (lens.along - run.usedLen) / 2;

    function toRoomXZ(posAlong, posAcross) {
      return stackAxis === 'x'
        ? { x: b.x0 + posAcross, z: b.z0 + posAlong }
        : { x: b.x0 + posAlong, z: b.z0 + posAcross };
    }

    var advanceAxis = (stackAxis === 'x') ? 'z' : 'x';
    var rotBack = (rotationDeg + 180) % 360;
    var cursorAcross = startAcross, rowsPlaced = 0, placed = 0, CAP = 300, capped = false;
    // p1 = fila más cercana al pasillo ANTERIOR (cursorAcross) → su frente debe
    // mirar hacia ESE pasillo, es decir hacia atrás → rotBack. p2 = fila más
    // cercana al pasillo SIGUIENTE → frente hacia delante → rotationDeg. (Antes
    // estaba al revés: los frentes del par quedaban enfrentados entre sí sobre
    // hueco 0 y las espaldas daban a los pasillos — bug real reportado.)
    for (var row = 0; row < nRows; row++) {
      for (var i = 0; i < run.units.length; i++) {
        if (placed >= CAP) { capped = true; break; }
        var p1 = toRoomXZ(startAlong + chainOffset(run, run.units[i], rotBack, advanceAxis), cursorAcross + unitAcross / 2);
        var p2 = toRoomXZ(startAlong + chainOffset(run, run.units[i], rotationDeg, advanceAxis), cursorAcross + unitAcross * 1.5);
        placeUnit(sink, gamaId, run.units[i].cfg, p1.x, p1.z, rotBack); placed++;
        placeUnit(sink, gamaId, run.units[i].cfg, p2.x, p2.z, rotationDeg); placed++;
      }
      if (capped) break;
      rowsPlaced++;
      cursorAcross += 2 * unitAcross + aisleMM;
    }
    if (!sink) { refreshOverlapState(); refreshPricesAndTotals(); }
    return { placed: placed, rows: rowsPlaced, perRow: run.units.length, capped: capped };
  }

  // Patrón 4: perímetro + islas centrales — perímetro primero, islas en el hueco restante.
  function autoFillPerimeterIslands(gamaId, cfgTemplate, opts, sink) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var fp = gama.footprintMM(cfgTemplate);
    var marginMM = 30;
    var aisleMM = opts.aisleMM || 900;
    var perim = autoFillPerimeter(gamaId, cfgTemplate, opts, sink);
    // Hueco central: pasillo COMPLETO (no solo margen mínimo) entre el frente
    // de las filas de perímetro y las islas, en los 4 lados — antes quedaba
    // apenas un margen de holgura entre el frente del perímetro y la isla.
    var inset = fp.depth + marginMM + aisleMM;
    var bounds = { x0: inset, x1: room.widthMM - inset, z0: inset, z1: room.depthMM - inset };
    if (bounds.x1 - bounds.x0 < fp.width || bounds.z1 - bounds.z0 < fp.depth * 2) {
      return { placed: perim.placed, rows: perim.rows, reason: perim.placed ? 'sin-hueco-central' : 'no-fit' };
    }
    var islands = autoFillIslands(gamaId, cfgTemplate, opts, bounds, sink);
    // `capped` de AMBAS mitades: antes solo se propagaba el de las islas, así que
    // un perímetro topado se aplicaba en silencio.
    return {
      placed: perim.placed + islands.placed, rows: perim.rows + islands.rows,
      capped: !!(perim.capped || islands.capped)
    };
  }

  // Único punto que limpia la sala antes de generar un patrón — evita que un
  // patrón se acumule sobre los items del patrón anterior (solapes fantasma).
  // En SIMULACIÓN (con sink) no se limpia nada: la sala del usuario no se toca
  // hasta que se aplica el ganador.
  function autoFill(gamaId, cfgTemplate, opts, sink) {
    if (!sink) { clearAllItems(); _budgetHit = false; }
    var pattern = (opts && opts.pattern) || 'rows';
    var res;
    if (pattern === 'perimeter') res = autoFillPerimeter(gamaId, cfgTemplate, opts, sink);
    else if (pattern === 'islands') res = autoFillIslands(gamaId, cfgTemplate, opts, null, sink);
    else if (pattern === 'perimeter-islands') res = autoFillPerimeterIslands(gamaId, cfgTemplate, opts, sink);
    else res = autoFillRows(gamaId, cfgTemplate, opts, sink);
    // El presupuesto global se aplica en placeUnit, que no puede devolver `capped`
    // por sí mismo: se recoge aquí para que CUALQUIER patrón avise del tope.
    if (!sink && _budgetHit) res.capped = true;
    return res;
  }

  // ─── Distribución óptima ───────────────────────────────────────────────────
  // Un patrón bien calculado NO debe solapar ni salirse de la sala; la candidata
  // que lo haga se descarta en vez de disimularse. La altura del producto frente
  // a la de la sala NO descalifica: eso es configuración del usuario y se avisa
  // con el mismo tinte rojo que en los 4 patrones normales.
  //
  // ⚠️ Distinguimos DOS causas, porque tratarlas igual entrena a ignorar la
  // consola: en una sala más estrecha que dos fondos de estantería, el patrón
  // PERÍMETRO se pisa a sí mismo (pared izquierda y derecha se solapan) y eso NO
  // es un bug — es una geometría imposible. Solo se avisa a voces cuando el
  // solape ocurre habiendo sitio de sobra, que sí sería un defecto del reparto.
  function optimalCandidateFault(sink, opts) {
    var i, j, r;
    for (i = 0; i < sink.rects.length; i++) {
      r = sink.rects[i];
      if (r.x0 < -0.5 || r.z0 < -0.5 || r.x1 > room.widthMM + 0.5 || r.z1 > room.depthMM + 0.5) return 'fuera-de-sala';
    }
    for (i = 0; i < sink.rects.length; i++) {
      for (j = i + 1; j < sink.rects.length; j++) {
        if (rectsOverlap(sink.rects[i], sink.rects[j])) {
          return sinkFitsInRoom(sink, opts) ? 'solape' : 'no-cabe';
        }
      }
    }
    return null;
  }
  // ¿Había sitio material para esta candidata? Un perímetro necesita dos fondos
  // más el pasillo en cada eje; por debajo de eso, el solape es inevitable.
  function sinkFitsInRoom(sink, opts) {
    if (!sink.units.length) return true;
    var fp = sink.units[0].footprint;
    var aisle = (opts && opts.aisleMM) || 900;
    var need = fp.depth * 2 + aisle;
    return room.widthMM >= need && room.depthMM >= need;
  }
  // ¿La solución mezcla anchuras? Se mira el VALOR DEL CAMPO de anchura, no el
  // ancho del footprint: en Media Carga una Extensión ya es más estrecha que su
  // Inicial (comparte bastidor) sin que haya mezcla de medidas ninguna.
  function sinkMixesWidths(gamaId, sink) {
    var field = widthFieldOf(gamaId);
    if (!field) return false;
    var seen = null;
    for (var i = 0; i < sink.units.length; i++) {
      var v = String(sink.units[i].cfg[field.key]);
      if (seen === null) seen = v;
      else if (v !== seen) return true;
    }
    return false;
  }

  var OPTIMAL_TIE_PCT = 0.01; // dentro del 1% = empate técnico → gana menos módulos
  // Evalúa en SIMULACIÓN 4 patrones × 2 ejes × espalda-con-espalda sí/no usando
  // packRunOptimized, puntúa por capacidad útil (metros lineales de balda) y
  // aplica el ganador de verdad. Las 16 candidatas no tocan ni la escena ni la
  // red: un auto-relleno completo cada una, cero GLB (ver makeDrySink). Si
  // ninguna coloca nada, la sala del usuario se queda COMO ESTABA.
  // Par (altura, niveles) con el que mejor se aprovecha el alto del espacio, SIN
  // contradecir al usuario. Dos casos, y la distinción es lo importante:
  //
  //   · **El usuario ha TOCADO los niveles** (su valor no es el de `defaultConfig`)
  //     ⇒ se RESPETAN, y se busca la altura MÁS BAJA que quepa y los admita. Más
  //     baja porque, a igual número de baldas, una estantería más alta cuesta más
  //     y no almacena más.
  //   · **Los niveles están en el valor por defecto** (no ha dicho nada) ⇒ se
  //     maximiza: la altura mayor que quepa y el máximo de niveles en ella. Es lo
  //     que convierte una nave de 6 m en 600 cm/4 niveles (450 palés) en vez de
  //     300 cm/2 niveles (270).
  //
  // ⚠️ Sin esa distinción esto fue un BUG reportado: con 4 niveles puestos a mano,
  // el botón los subía a 7 "siempre". Maximizar es lo que se pidió para el alto,
  // pero pisar una elección explícita se lee como que el selector no funciona.
  // Nota: tras pulsar el botón una vez, los niveles ya difieren del defecto, así
  // que una segunda pulsación los respeta — no escala sin parar.
  //
  // Devuelve null si la gama no tiene campo de altura o si NINGUNA medida cabe:
  // entonces se respeta la config tal cual y el aviso de siempre dice que no cabe.
  function bestHeightAndLevels(gamaId, cfg) {
    var gama = SpaceCatalog.GAMAS[gamaId];
    var field = heightFieldOf(gamaId);
    if (!gama || !field || typeof gama.nivelesFor !== 'function') return null;
    var userN = parseInt(cfg.niveles, 10) || 0;
    var defN = 0;
    try { defN = parseInt(gama.defaultConfig().niveles, 10) || 0; } catch (e) { defN = 0; }
    // La bandera es la señal FIABLE (el usuario tocó el selector); la comparación con el
    // defecto cubre lo que llega por otra vía —un enlace compartido, una config
    // restaurada— donde no hubo ningún clic que marcar.
    var explicito = nivelesTocados || (userN > 0 && userN !== defN);
    var best = null;
    for (var i = 0; i < field.options.length; i++) {
      var probe = Object.assign({}, cfg);
      probe[field.key] = field.options[i];
      var h;
      try { h = gama.footprintMM(probe).height; } catch (e) { continue; }
      if (h > room.heightMM + 1) continue;
      var validN = gama.nivelesFor(probe).map(Number).filter(function (n) { return n > 0; });
      if (!validN.length) continue;                       // p.ej. un hueco de surtido
      if (explicito) {
        if (validN.indexOf(userN) === -1) continue;       // esta altura no admite SUS niveles
        if (!best || h < best.h) best = { key: field.key, height: field.options[i], niveles: userN, h: h };
      } else {
        var maxN = Math.max.apply(null, validN);
        if (!best || maxN > best.niveles || (maxN === best.niveles && h > best.h)) {
          best = { key: field.key, height: field.options[i], niveles: maxN, h: h };
        }
      }
    }
    // Sus niveles no existen en NINGUNA altura que quepa: mejor adaptar el número
    // que no proponer nada. Se reintenta con el valor por defecto, lo que hace
    // `explicito` falso en la llamada recursiva ⇒ termina siempre.
    if (!best && explicito && defN > 0) {
      var relax = Object.assign({}, cfg);
      relax.niveles = defN;
      return bestHeightAndLevels(gamaId, relax);
    }
    return best;
  }

  function autoFillOptimal(gamaId, cfgTemplate, opts) {
    if (!SpaceCatalog.GAMAS[gamaId]) return { placed: 0, reason: 'no-gama' };
    // El ALTO del espacio también se aprovecha. Antes las 16 candidatas se
    // simulaban con la altura que tuviera puesta el usuario, así que subir el alto
    // del espacio no cambiaba nada: el óptimo seguía proponiendo estanterías bajas
    // y dejaba metros de aire (reportado, ago-2026).
    // NO hace falta multiplicar las simulaciones por cada altura: ni la altura ni
    // los niveles entran en `footprintMM().width/depth`, así que la GEOMETRÍA de
    // las 16 candidatas es idéntica para cualquier altura y lo único que cambia es
    // la puntuación, que es Σ(ancho de balda × niveles). Basta elegir ANTES el par
    // (altura, niveles) que más baldas da y simular con él.
    // ⚠️ Se muta `cfgTemplate` A PROPÓSITO (es `activeCfg`): si el óptimo colocase
    // una altura distinta de la que enseña el panel, el panel mentiría y la
    // siguiente unidad añadida a mano saldría con otra medida. Quien llama debe
    // repintar los campos (`renderProductFields()`).
    var pick = bestHeightAndLevels(gamaId, cfgTemplate);
    if (pick) { cfgTemplate[pick.key] = pick.height; cfgTemplate.niveles = pick.niveles; }
    var base = opts || {};
    var patterns = ['rows', 'perimeter', 'islands', 'perimeter-islands'];
    var axes = ['z', 'x'];
    var backs = [false, true];
    var cands = [], p, a, b, i;
    for (p = 0; p < patterns.length; p++) {
      for (a = 0; a < axes.length; a++) {
        for (b = 0; b < backs.length; b++) {
          var o = {
            pattern: patterns[p], aisleMM: base.aisleMM || 900,
            stackAxis: axes[a], backToBack: backs[b], optimizePack: true
          };
          var sink = makeDrySink();
          var res = autoFill(gamaId, cfgTemplate, o, sink);
          if (!sink.units.length) continue;
          var fault = optimalCandidateFault(sink, o);
          if (fault) {
            // 'no-cabe' es esperado (sala más estrecha que el patrón): a debug.
            // 'solape'/'fuera-de-sala' habiendo sitio SÍ es un defecto: a warn.
            if (fault === 'no-cabe') { if (console.debug) console.debug('[SpaceConfigurator] candidata no cabe', o); }
            else console.warn('[SpaceConfigurator] candidata descartada (' + fault + ')', o);
            continue;
          }
          cands.push({
            opts: o, capacityMM: sink.capacityMM, count: sink.units.length,
            mixed: sinkMixesWidths(gamaId, sink), capped: !!res.capped
          });
        }
      }
    }
    if (!cands.length) return { placed: 0, reason: 'no-fit' };

    // Ganador en DOS pasadas, no con un "mejor hasta ahora" que aplique la
    // tolerancia del 1% por parejas: esa relación no es transitiva y el resultado
    // dependería del orden de evaluación. 1) máxima capacidad; 2) entre las que
    // están dentro del 1% de ese máximo, la de menos unidades (empate → la primera).
    var maxCap = 0;
    for (i = 0; i < cands.length; i++) if (cands[i].capacityMM > maxCap) maxCap = cands[i].capacityMM;
    var winner = null;
    if (maxCap <= 0) {
      // Config degenerada sin niveles (p.ej. un enlace compartido incompleto): no
      // hay metros de balda que puntuar, así que se cae a "más unidades
      // colocadas" — que sí se puede medir. Sin esto ganaría la distribución MÁS
      // VACÍA, por el desempate de "menos módulos".
      for (i = 0; i < cands.length; i++) if (!winner || cands[i].count > winner.count) winner = cands[i];
    } else {
      for (i = 0; i < cands.length; i++) {
        if ((maxCap - cands[i].capacityMM) / maxCap > OPTIMAL_TIE_PCT) continue;
        if (!winner || cands[i].count < winner.count) winner = cands[i];
      }
    }
    if (!winner) winner = cands[0];

    // Solo aquí se toca la sala: autoFill() limpia UNA vez y coloca de verdad.
    // Mismo `opts` ⇒ mismo reparto que la simulación (packRunOptimized incluido).
    var applied = autoFill(gamaId, cfgTemplate, winner.opts);
    if (applied.placed !== winner.count) {
      console.warn('[SpaceConfigurator] simulación ' + winner.count + ' unidades vs aplicación ' +
        applied.placed + ' — el patrón no es determinista, revísalo', winner.opts);
    }
    return {
      placed: applied.placed, rows: applied.rows, pattern: winner.opts.pattern,
      capacityMM: winner.capacityMM, mixed: winner.mixed,
      capped: !!(applied.capped || winner.capped), candidates: cands.length
    };
  }

  // ─── Selección, arrastre, toolbar flotante ─────────────────────────────────
  function pointerToRoomMM(clientX, clientY) {
    var rect = renderer.domElement.getBoundingClientRect();
    var ndc = new THREE.Vector2(((clientX - rect.left) / rect.width) * 2 - 1, -((clientY - rect.top) / rect.height) * 2 + 1);
    raycaster.setFromCamera(ndc, camera);
    if (!floorMesh) return null;
    var hits = raycaster.intersectObject(floorMesh, false);
    if (!hits.length) return null;
    return { xMM: (hits[0].point.x / MM_TO_WORLD) + room.widthMM / 2, zMM: hits[0].point.z / MM_TO_WORLD };
  }
  function raycastItemAt(clientX, clientY) {
    var rect = renderer.domElement.getBoundingClientRect();
    var ndc = new THREE.Vector2(((clientX - rect.left) / rect.width) * 2 - 1, -((clientY - rect.top) / rect.height) * 2 + 1);
    raycaster.setFromCamera(ndc, camera);
    var groups = items.map(function (i) { return i.group; }).filter(Boolean);
    var hits = raycaster.intersectObjects(groups, true);
    return hits.length ? findItemIdFromObject(hits[0].object) : null;
  }

  var selectionHighlight = null;
  function updateSelectionHighlight() {
    if (selectionHighlight) { scene.remove(selectionHighlight); selectionHighlight = null; }
    var item = selectedItemId != null ? getItem(selectedItemId) : null;
    if (!item || !item.group) return;
    var box = new THREE.Box3().setFromObject(item.group);
    selectionHighlight = new THREE.Box3Helper(box, 0xF24507);
    scene.add(selectionHighlight);
  }

  function selectItem(id) {
    selectedItemId = id;
    updateSelectionHighlight();
    updateDimLinesForSelection();
    renderItemsListUI();
    renderEditPanel();
  }
  function deselectItem() {
    selectedItemId = null;
    var tb = document.getElementById('item-toolbar'); if (tb) tb.style.display = 'none';
    updateSelectionHighlight();
    updateDimLinesForSelection();
    renderItemsListUI();
    renderEditPanel();
  }

  // Control SEGMENTADO: los dos modos siempre visibles y el ACTIVO resaltado
  // ("dónde estás", no "a dónde irás" — el botón único confundía).
  function setEditMode(on) {
    editMode = on;
    controls.enableRotate = !on;
    controls.enablePan = !on;
    var bView = document.getElementById('mode-view-btn'), bEdit = document.getElementById('mode-edit-btn');
    if (bView) bView.classList.toggle('active', !editMode);
    if (bEdit) bEdit.classList.toggle('active', editMode);
    var hint = document.getElementById('mode-hint');
    if (hint) hint.textContent = editMode ? t('hint_edit') : t('hint_view');
  }

  // ─── Hit-test / conversión de puntero en la vista en PLANTA (canvas 2D) —
  // inversa exacta de px()/py() de drawFloorPlan, reutilizando planViewTransform. ──
  var planViewTransform = null;
  function planPointerToRoomMM(clientX, clientY) {
    var canvas = document.getElementById('plan-canvas'); if (!canvas || !planViewTransform) return null;
    var rect = canvas.getBoundingClientRect(); var t = planViewTransform;
    return { xMM: (clientX - rect.left - t.offX) / t.scale, zMM: (clientY - rect.top - t.offY) / t.scale };
  }
  function planHitTest(clientX, clientY) {
    var pt = planPointerToRoomMM(clientX, clientY); if (!pt) return null;
    for (var i = items.length - 1; i >= 0; i--) {
      var r = itemRectMM(items[i]);
      if (pt.xMM >= r.x0 && pt.xMM <= r.x1 && pt.zMM >= r.z0 && pt.zMM <= r.z1) return items[i].id;
    }
    return null;
  }
  function redrawPlanIfActive() {
    if (viewMode === 'plan') { var pc = document.getElementById('plan-canvas'); if (pc) drawFloorPlan(pc); }
  }

  function onPointerDown(e) {
    _pointerDownOnCanvas = true;
    _ptrDownX = e.clientX; _ptrDownY = e.clientY;
    var hitId = (viewMode === 'plan') ? planHitTest(e.clientX, e.clientY) : raycastItemAt(e.clientX, e.clientY);
    dragCandidateId = hitId;
    if (hitId != null) {
      var item = getItem(hitId);
      var pt = (viewMode === 'plan') ? planPointerToRoomMM(e.clientX, e.clientY) : pointerToRoomMM(e.clientX, e.clientY);
      dragOffset = pt ? { x: pt.xMM - item.xMM, z: pt.zMM - item.zMM } : { x: 0, z: 0 };
    }
  }
  // Snap magnético al arrastrar: si un borde queda a <30mm del borde de otro
  // producto, se ajusta a la separación exacta (10mm, o 0mm entre módulos de
  // Media Carga compatibles — mismo alto/fondo/rotación — para poder encadenar
  // al soltar). Sin vecino cerca, rejilla de 50mm. Esto hace posible "volver a
  // meter" un producto en su hueco (antes era imposible acertar al mm).
  var MAGNET_RANGE_MM = 30;
  function magneticSnap(item, xMM, zMM) {
    var fw = itemFootprintWD(item);
    var bestX = null, bestZ = null;
    for (var i = 0; i < items.length; i++) {
      var o = items[i];
      if (o.id === item.id) continue;
      var or = itemRectMM(o);
      var chainable = sameChainFrame(item, o);
      var gapWant = chainable ? 0 : SIDE_GAP_MM;
      var zOverlap = Math.min(zMM + fw.d / 2, or.z1) - Math.max(zMM - fw.d / 2, or.z0);
      var xOverlap = Math.min(xMM + fw.w / 2, or.x1) - Math.max(xMM - fw.w / 2, or.x0);
      if (zOverlap > 0) {
        var cands = [or.x1 + gapWant + fw.w / 2, or.x0 - gapWant - fw.w / 2];
        for (var a = 0; a < 2; a++) {
          var dxa = Math.abs(cands[a] - xMM);
          if (dxa <= MAGNET_RANGE_MM && (!bestX || dxa < bestX.dist)) bestX = { target: cands[a], dist: dxa };
        }
      }
      if (xOverlap > 0) {
        var candsZ = [or.z1 + gapWant + fw.d / 2, or.z0 - gapWant - fw.d / 2];
        for (var b = 0; b < 2; b++) {
          var dzb = Math.abs(candsZ[b] - zMM);
          if (dzb <= MAGNET_RANGE_MM && (!bestZ || dzb < bestZ.dist)) bestZ = { target: candsZ[b], dist: dzb };
        }
      }
    }
    return {
      xMM: bestX ? bestX.target : Math.round(xMM / 50) * 50,
      zMM: bestZ ? bestZ.target : Math.round(zMM / 50) * 50
    };
  }

  function onPointerMoveGlobal(e) {
    if (!_pointerDownOnCanvas || dragCandidateId == null) return;
    // En 3D, 'Mover vista' reserva el arrastre para orbitar la cámara (OrbitControls,
    // sin interferir). En planta no hay cámara que orbitar: arrastrar siempre mueve.
    if (viewMode !== 'plan' && !editMode) return;
    var dx = e.clientX - _ptrDownX, dy = e.clientY - _ptrDownY;
    if (!isDragging && (dx * dx + dy * dy) > 36) { isDragging = true; selectItem(dragCandidateId); }
    if (!isDragging) return;
    var item = getItem(dragCandidateId); if (!item) return;
    var pt = (viewMode === 'plan') ? planPointerToRoomMM(e.clientX, e.clientY) : pointerToRoomMM(e.clientX, e.clientY);
    if (!pt) return;
    var fw = itemFootprintWD(item);
    var snapped = magneticSnap(item, pt.xMM - dragOffset.x, pt.zMM - dragOffset.z);
    item.xMM = clamp(snapped.xMM, fw.w / 2, room.widthMM - fw.w / 2);
    item.zMM = clamp(snapped.zMM, fw.d / 2, room.depthMM - fw.d / 2);
    positionItemGroup(item);
    refreshOverlapState();
    updateDimLinesForSelection();
    redrawPlanIfActive();
  }
  // Solo (de)selecciona si el gesto empezó en un canvas — un click en la toolbar
  // flotante o en el panel lateral también dispara pointerup en window (burbujeo)
  // y NO debe deseleccionar antes de que el click del propio botón se procese.
  function onPointerUpGlobal() {
    if (!_pointerDownOnCanvas) return;
    _pointerDownOnCanvas = false;
    var wasDragging = isDragging;
    if (!isDragging && dragCandidateId != null) selectItem(dragCandidateId);
    else if (!isDragging && dragCandidateId == null) deselectItem();
    isDragging = false; dragCandidateId = null;
    if (wasDragging) { normalizeChainedUnitTypes(); redrawPlanIfActive(); } // fin de arrastre: revalidar cadenas MC
  }

  function updateToolbarPosition() {
    var tb = document.getElementById('item-toolbar'); if (!tb) return;
    var item = selectedItemId != null ? getItem(selectedItemId) : null;
    if (!item || !item.group) { tb.style.display = 'none'; return; }
    if (viewMode === 'plan') {
      if (!planViewTransform) { tb.style.display = 'none'; return; }
      var r = itemRectMM(item); var t = planViewTransform;
      var x = t.offX + ((r.x0 + r.x1) / 2) * t.scale;
      var yTop = t.offY + r.z0 * t.scale;
      tb.style.display = 'flex'; tb.style.left = x + 'px'; tb.style.top = Math.max(0, yTop - 40) + 'px';
      return;
    }
    var box = new THREE.Box3().setFromObject(item.group);
    var top = new THREE.Vector3((box.min.x + box.max.x) / 2, box.max.y, (box.min.z + box.max.z) / 2);
    var proj = top.clone().project(camera);
    var canvas = renderer.domElement;
    var x2 = (proj.x * 0.5 + 0.5) * canvas.clientWidth;
    var y2 = (1 - (proj.y * 0.5 + 0.5)) * canvas.clientHeight;
    tb.style.display = (proj.z < 1) ? 'flex' : 'none';
    tb.style.left = x2 + 'px';
    tb.style.top = Math.max(0, y2 - 44) + 'px';
  }

  function rotateSelected() {
    var item = getItem(selectedItemId); if (!item) return;
    item.rotationDeg = ((item.rotationDeg || 0) + 90) % 360;
    positionItemGroup(item); refreshOverlapState(); updateDimLinesForSelection();
    normalizeChainedUnitTypes(); redrawPlanIfActive();
  }
  function duplicateSelected() {
    var item = getItem(selectedItemId); if (!item) return;
    var fw = itemFootprintWD(item);
    var newX = item.xMM + fw.w + sideGapFor(item.gamaId);
    if (newX + fw.w / 2 > room.widthMM) newX = item.xMM;
    var created = addItem(item.gamaId, item.cfg, clamp(newX, fw.w / 2, room.widthMM - fw.w / 2), item.zMM, item.rotationDeg);
    selectItem(created.id);
    refreshPricesAndTotals();
    normalizeChainedUnitTypes(); redrawPlanIfActive();
  }
  function deleteSelected() {
    var item = getItem(selectedItemId); if (!item) return;
    if (item.group) { scene.remove(item.group); disposeGroupDeep(item.group); }
    items = items.filter(function (i) { return i.id !== item.id; });
    deselectItem(); refreshOverlapState(); refreshPricesAndTotals();
    normalizeChainedUnitTypes(); redrawPlanIfActive(); // borrar una Inicial puede dejar Extensiones colgando
  }

  // ─── Media Carga: una Extensión JAMÁS puede quedar colgando (misma lógica
  // que normalizeUnitTypes() del configurador de producto real, adaptada a
  // posiciones libres en el plano en vez de un array secuencial de units[]).
  // Una Extensión es válida si, siguiendo la cadena de vecinos, se llega a una
  // Inicial. Si no, se auto-degrada a Inicial — nunca queda inválida. ──

  function normRot(deg) { return ((Math.round(deg || 0) % 360) + 360) % 360; }
  // Vector MUNDO del lado SIN bastidor de una Extensión (su -X local rotado
  // por rotation.y): 0°→-X · 90°→+Z · 180°→+X · 270°→-Z. El vecino que le
  // presta el bastidor tiene que estar EXACTAMENTE en ese lado — un vecino en
  // el lado del bastidor propio no sostiene nada (causa raíz del bug de la
  // extensión colgando en filas a 180°).
  function openSideDir(rotationDeg) {
    var rad = normRot(rotationDeg) * Math.PI / 180;
    return { x: -Math.cos(rad), z: Math.sin(rad) };
  }

  // ¿Comparten estos dos ítems el MISMO bastidor? Misma gama, misma orientación exacta
  // y coincidencia en los campos que el catálogo declara como definitorios del bastidor
  // (`chain.matchKeys`). El ancho NO está entre ellos a propósito: dos módulos de
  // anchura distinta comparten bastidor sin problema, y el auto-relleno óptimo mezcla
  // anchuras. Lo usan tanto el imán al arrastrar como la validación de la cadena, para
  // que no puedan discrepar.
  function sameChainFrame(a, b) {
    if (!a || !b || a.gamaId !== b.gamaId) return false;
    var ch = chainOf(a.gamaId);
    if (!ch) return false;
    if (normRot(a.rotationDeg) !== normRot(b.rotationDeg)) return false;
    for (var i = 0; i < ch.matchKeys.length; i++) {
      var k = ch.matchKeys[i];
      if (String(a.cfg[k]) !== String(b.cfg[k])) return false;
    }
    return true;
  }

  function findChainNeighbor(item, others) {
    var dir = openSideDir(item.rotationDeg);
    var r = itemRectMM(item);
    for (var i = 0; i < others.length; i++) {
      var o = others[i];
      if (o.id === item.id) continue;
      if (!sameChainFrame(item, o)) continue;
      var orect = itemRectMM(o);
      var gap, overlap;
      if (Math.abs(dir.x) > 0.5) {
        overlap = Math.min(r.z1, orect.z1) - Math.max(r.z0, orect.z0);
        gap = dir.x > 0 ? (orect.x0 - r.x1) : (r.x0 - orect.x1);
      } else {
        overlap = Math.min(r.x1, orect.x1) - Math.max(r.x0, orect.x0);
        gap = dir.z > 0 ? (orect.z0 - r.z1) : (r.z0 - orect.z1);
      }
      if (overlap > 0 && gap >= -2 && gap <= 20) return o;
    }
    return null;
  }
  function isChainedToFull(item, visited) {
    visited = visited || {};
    if (visited[item.id]) return false; // ciclo — no debería pasar, pero corta la recursión
    visited[item.id] = true;
    var ch = chainOf(item.gamaId);
    if (!ch) return true;
    if ((item.cfg.unitType || ch.full) === ch.full) return true;
    var others = items.filter(function (i) { return i.id !== item.id; });
    var neighbor = findChainNeighbor(item, others);
    return neighbor ? isChainedToFull(neighbor, visited) : false;
  }
  // Red de seguridad: un módulo que comparte bastidor y se queda sin vecino que se lo
  // preste se convierte en módulo completo. Sirve para CUALQUIER gama con cadena (antes
  // solo Media Carga), y se llama tras cualquier mutación: borrar, arrastrar, duplicar,
  // editar, añadir o auto-rellenar.
  function normalizeChainedUnitTypes() {
    var changed = false;
    items.forEach(function (item) {
      var ch = chainOf(item.gamaId);
      if (!ch || (item.cfg.unitType || ch.full) !== ch.shared) return;
      if (!isChainedToFull(item)) {
        item.cfg = Object.assign({}, item.cfg, { unitType: ch.full });
        item.footprint = SpaceCatalog.GAMAS[item.gamaId].footprintMM(item.cfg);
        loadAndPlaceItem(item);
        changed = true;
        if (item.id === selectedItemId) renderEditPanel();
      }
    });
    if (changed) { showToast(t('chain_demoted')); refreshOverlapState(); refreshPricesAndTotals(); }
    return changed;
  }

  // ─── Sala ───────────────────────────────────────────────────────────────────
  function buildRoom() {
    if (roomGroup) { scene.remove(roomGroup); disposeGroupDeep(roomGroup); }
    roomGroup = new THREE.Group();
    var w = mm(room.widthMM), d = mm(room.depthMM), h = mm(room.heightMM);

    var floorMat = new THREE.MeshBasicMaterial({ color: 0xF7F7F7, side: THREE.DoubleSide });
    floorMesh = new THREE.Mesh(new THREE.PlaneGeometry(w, d), floorMat);
    floorMesh.rotation.x = -Math.PI / 2;
    floorMesh.position.set(0, 0, d / 2);
    roomGroup.add(floorMesh);

    var divisions = Math.max(4, Math.round(Math.max(room.widthMM, room.depthMM) / 500));
    var grid = new THREE.GridHelper(Math.max(w, d) * 1.05, divisions, 0xC8C8C8, 0xDCDCDC);
    grid.position.set(0, 0.002, d / 2);
    grid.material.opacity = 0.35; grid.material.transparent = true;
    roomGroup.add(grid);

    var wallMat = new THREE.MeshBasicMaterial({ color: 0xF2F2F2, side: THREE.DoubleSide, transparent: true, opacity: 0.5 });
    var backWall = new THREE.Mesh(new THREE.PlaneGeometry(w, h), wallMat);
    backWall.position.set(0, h / 2, 0);
    roomGroup.add(backWall);

    var leftWall = new THREE.Mesh(new THREE.PlaneGeometry(d, h), wallMat.clone());
    leftWall.rotation.y = Math.PI / 2;
    leftWall.position.set(-w / 2, h / 2, d / 2);
    roomGroup.add(leftWall);

    var outlinePts = [
      new THREE.Vector3(-w / 2, 0.005, 0), new THREE.Vector3(w / 2, 0.005, 0),
      new THREE.Vector3(w / 2, 0.005, d), new THREE.Vector3(-w / 2, 0.005, d),
      new THREE.Vector3(-w / 2, 0.005, 0)
    ];
    var outline = new THREE.Line(new THREE.BufferGeometry().setFromPoints(outlinePts), new THREE.LineBasicMaterial({ color: 0xF24507 }));
    roomGroup.add(outline);

    addFloorLogo(Math.min(w, d) * 0.35, d / 2);

    scene.add(roomGroup);

    var wl = document.getElementById('room-dim-width'), dl = document.getElementById('room-dim-depth'), hl = document.getElementById('room-dim-height');
    if (wl) wl.textContent = (room.widthMM / 10) + ' cm';
    if (dl) dl.textContent = (room.depthMM / 10) + ' cm';
    if (hl) hl.textContent = (room.heightMM / 10) + ' cm';

    // Cotas permanentes de ancho/fondo — se reconstruyen con la sala (dependen
    // de sus medidas). No hace falta rehacerlas en onResize: son geometría 3D y
    // la cámara las reproyecta sola; sus etiquetas las mueve updateDimLabelPositions().
    buildRoomDimLines();

    items.forEach(positionItemGroup);
  }

  // Logo Master Rax en el suelo — mismo patrón que los configuradores de
  // producto (addFloorLogo/buildFloorLogoMesh): intenta recortar el fondo
  // blanco vía canvas; si el CDN no da CORS, usa la imagen sin procesar.
  function addFloorLogo(sizeWorld, worldZ) {
    var logoUrl = (window.SpaceConfiguratorData && window.SpaceConfiguratorData.logoUrl) ||
      'https://cdn.shopify.com/s/files/1/0999/8834/1123/files/LogoMaster_26_square.png?v=1780060507';
    var targetGroup = roomGroup;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
        var canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
        var ctx = canvas.getContext('2d'); ctx.drawImage(img, 0, 0);
        var imageData = ctx.getImageData(0, 0, w, h);
        var d = imageData.data;
        for (var i = 0; i < d.length; i += 4) {
          var lum = d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114;
          if (lum > 200) d[i + 3] = 0;
          else if (lum > 140) d[i + 3] = Math.round((1 - (lum - 140) / 60) * d[i + 3]);
        }
        ctx.putImageData(imageData, 0, 0);
        buildFloorLogoMesh(new THREE.CanvasTexture(canvas), THREE.NormalBlending, 0.10, sizeWorld, worldZ, targetGroup);
      } catch (e) {
        try {
          var texFallback = new THREE.Texture(img); texFallback.needsUpdate = true;
          buildFloorLogoMesh(texFallback, THREE.MultiplyBlending, 0.18, sizeWorld, worldZ, targetGroup);
        } catch (e2) { console.warn('[SpaceConfigurator] Logo suelo no disponible:', e2); }
      }
    };
    img.onerror = function () {
      var img2 = new Image();
      img2.onload = function () {
        try {
          var tex2 = new THREE.Texture(img2); tex2.needsUpdate = true;
          buildFloorLogoMesh(tex2, THREE.MultiplyBlending, 0.18, sizeWorld, worldZ, targetGroup);
        } catch (e) {}
      };
      img2.src = logoUrl + (logoUrl.indexOf('?') > -1 ? '&nc=1' : '?nc=1');
    };
    img.src = logoUrl;
  }
  function buildFloorLogoMesh(tex, blending, opacity, sizeWorld, worldZ, targetGroup) {
    if (targetGroup !== roomGroup) return; // la sala se reconstruyó mientras cargaba la imagen: descartar
    var mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true, opacity: opacity, depthWrite: false, blending: blending });
    var mesh = new THREE.Mesh(new THREE.PlaneGeometry(sizeWorld, sizeWorld), mat);
    mesh.rotation.x = -Math.PI / 2;
    mesh.position.set(0, 0.003, worldZ);
    mesh.renderOrder = 1;
    roomGroup.add(mesh);
  }

  // Pose "de inicio" de la sala (encuadre isométrico por defecto) — misma
  // fórmula que usaba frameCameraToRoom antes de animar los presets, extraída
  // aquí para que 'iso' (botón Reset) y la carga inicial la compartan.
  function roomHomePose() {
    var w = mm(room.widthMM), d = mm(room.depthMM), h = mm(room.heightMM);
    var reach = Math.max(w, d);
    return {
      pos: new THREE.Vector3(reach * 0.55 + 1, h * 0.9 + 1.5, d + reach * 0.45 + 1.5),
      look: new THREE.Vector3(0, h * 0.35, d / 2)
    };
  }
  // Encuadre INSTANTÁNEO (init y al redimensionar la sala) — nunca se anima
  // aquí: solo setCameraPreset/fitAllItems animan el salto hacia esta pose.
  function frameCameraToRoom() {
    var w = mm(room.widthMM), d = mm(room.depthMM);
    var reach = Math.max(w, d);
    var home = roomHomePose();
    controls.target.copy(home.look);
    perspCam.position.copy(home.pos);
    controls.maxDistance = reach * 4 + 10;
    controls.minDistance = 0.4;
    controls.update();
  }

  // ─── Animación suave de cámara (easeInOutQuad) — portada de configurator.js
  // (RIVET PRO). Guard _camAnimId: cada llamada nueva incrementa el contador;
  // el step de una animación anterior lo comprueba y se abandona si ya no es
  // la vigente (dos presets pulsados rápido no deben pelearse por la cámara).
  // No depende de editMode: mueve perspCam.position/controls.target a mano vía
  // rAF (no pointer/OrbitControls), así que enableRotate=false no lo bloquea.
  var _camAnimId = 0;
  function animateCameraTo(targetPos, targetLook, ms) {
    var myId = ++_camAnimId;
    var startPos = perspCam.position.clone();
    var startTarget = controls.target.clone();
    var duration = ms || 420;
    var startTime = null;
    function step(ts) {
      if (myId !== _camAnimId) return; // otra animación tomó el relevo: abandonar
      if (!startTime) startTime = ts;
      var elapsed = ts - startTime;
      var t = Math.min(elapsed / duration, 1);
      t = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      perspCam.position.lerpVectors(startPos, targetPos, t);
      controls.target.lerpVectors(startTarget, targetLook, t);
      controls.update();
      if (elapsed < duration) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // La "vista en planta" NO es la cámara ortográfica 3D (materiales/luces daban
  // mal contraste) sino un dibujo 2D dedicado (drawFloorPlan) con colores planos
  // y todas las cotas — más legible y no depende del renderizado 3D.
  function toggleViewMode() {
    viewMode = (viewMode === 'orbit') ? 'plan' : 'orbit';
    var canvas3d = document.getElementById('configurator-canvas');
    var canvasPlan = document.getElementById('plan-canvas');
    if (viewMode === 'plan') {
      if (canvas3d) canvas3d.style.display = 'none';
      if (canvasPlan) { canvasPlan.style.display = 'block'; drawFloorPlan(canvasPlan); }
    } else {
      if (canvas3d) canvas3d.style.display = 'block';
      if (canvasPlan) canvasPlan.style.display = 'none';
    }
    var btn = document.getElementById('view-toggle-btn');
    // Único texto de botón que pinta el JS (alterna): el resto los sirve el Liquid.
    if (btn) btn.textContent = viewMode === 'plan' ? ('⬚ ' + t('view_3d')) : ('▦ ' + t('view_plan'));
  }
  function ensurePerspective() {
    if (viewMode === 'plan') toggleViewMode();
  }

  // ─── Plano 2D acotado (planta) — Canvas 2D puro, no Three.js. Reutilizable
  // para el panel de planta Y para insertarlo en el presupuesto PDF. ──────────
  function computeClearances(item) {
    var r = itemRectMM(item);
    var res = { toBack: r.z0, toFront: room.depthMM - r.z1, toLeft: r.x0, toRight: room.widthMM - r.x1,
      neighborLeft: null, neighborRight: null, neighborBack: null, neighborFront: null };
    items.forEach(function (other) {
      if (other.id === item.id) return;
      var o = itemRectMM(other);
      var overlapZ = Math.min(r.z1, o.z1) - Math.max(r.z0, o.z0);
      var overlapX = Math.min(r.x1, o.x1) - Math.max(r.x0, o.x0);
      if (overlapZ > 0) {
        if (o.x1 <= r.x0) { var g = r.x0 - o.x1; if (!res.neighborLeft || g < res.neighborLeft.gap) res.neighborLeft = { gap: g, id: other.id }; }
        if (o.x0 >= r.x1) { var g2 = o.x0 - r.x1; if (!res.neighborRight || g2 < res.neighborRight.gap) res.neighborRight = { gap: g2, id: other.id }; }
      }
      if (overlapX > 0) {
        if (o.z1 <= r.z0) { var g3 = r.z0 - o.z1; if (!res.neighborBack || g3 < res.neighborBack.gap) res.neighborBack = { gap: g3, id: other.id }; }
        if (o.z0 >= r.z1) { var g4 = o.z0 - r.z1; if (!res.neighborFront || g4 < res.neighborFront.gap) res.neighborFront = { gap: g4, id: other.id }; }
      }
    });
    return res;
  }

  // ─── Cotas en vivo en el visor 3D (solo el ítem seleccionado: paredes + vecino
  // más próximo en cada dirección). Líneas THREE + etiquetas HTML proyectadas,
  // mismo patrón que createDimLines/updateDimLabels de los configuradores de
  // producto, simplificado a lo que hace falta aquí. ────────────────────────
  var dimLinesGroup = null;
  var DIM_LABEL_IDS = ['dim-back', 'dim-front', 'dim-left', 'dim-right', 'dim-nbL', 'dim-nbR', 'dim-nbB', 'dim-nbF'];
  var dimLabelData = {};

  // ── Cotas PERMANENTES de la SALA (ancho y fondo) — grupo, ids y datos PROPIOS,
  // deliberadamente SEPARADOS de los de arriba. updateDimLinesForSelection()
  // reconstruye dimLinesGroup en cada (de)selección y clearDimLines() lo BORRA:
  // si estas dos cotas vivieran en ese grupo (o sus ids en DIM_LABEL_IDS)
  // desaparecerían al seleccionar/deseleccionar una estantería, que es justo lo
  // contrario de lo que se pide (deben verse SIEMPRE, para saber qué medida es
  // el ancho y cuál el fondo). NO fusionar estas dos colecciones. ──
  var roomDimGroup = null;
  var ROOM_DIM_IDS = ['dim-room-w', 'dim-room-d'];
  var roomDimLabelData = {};

  function initDimLabels(container) {
    DIM_LABEL_IDS.forEach(function (id) {
      var el = document.createElement('div'); el.id = id; el.className = 'dim-label'; el.style.display = 'none';
      container.appendChild(el);
    });
    ROOM_DIM_IDS.forEach(function (id) {
      var el = document.createElement('div'); el.id = id; el.className = 'dim-label dim-label--room'; el.style.display = 'none';
      container.appendChild(el);
    });
  }
  // OJO: esto limpia SOLO las cotas del ítem seleccionado. Las de la sala
  // (roomDimGroup / ROOM_DIM_IDS / roomDimLabelData) son permanentes y las
  // gestiona buildRoomDimLines() desde buildRoom() — no tocarlas aquí.
  function clearDimLines() {
    if (dimLinesGroup) { scene.remove(dimLinesGroup); dimLinesGroup = null; }
    dimLabelData = {};
    DIM_LABEL_IDS.forEach(function (id) { var el = document.getElementById(id); if (el) el.style.display = 'none'; });
  }

  // Las líneas de cota son THREE.Line, no Mesh: disposeGroupDeep() las ignoraría
  // (filtra por isMesh), así que se liberan aquí.
  function disposeLineGroup(group) {
    group.traverse(function (c) {
      if (c.geometry) c.geometry.dispose();
      if (c.material) { var ms = Array.isArray(c.material) ? c.material : [c.material]; ms.forEach(function (m) { if (m) m.dispose(); }); }
    });
  }

  // Cotas de ANCHO (eje X) y FONDO (eje Z) de la sala, a ras de suelo y justo
  // FUERA del rectángulo, con el MISMO estilo de terminadores que seg(): así se
  // ve entre qué bordes mide cada número. Posición elegida contra roomHomePose()
  // (cámara en +X/+Z mirando a -Z) y para casar con la vista en planta, que
  // rotula el ancho arriba (pared trasera, z=0) y el fondo a la izquierda (x=0):
  //   · ancho  → z = -25cm (fuera de la pared trasera)
  //   · fondo  → x = -25cm respecto de la pared izquierda
  // Van a y≈2cm (las del ítem seleccionado van a media altura) para no cruzarse.
  function buildRoomDimLines() {
    if (roomDimGroup) { scene.remove(roomDimGroup); disposeLineGroup(roomDimGroup); roomDimGroup = null; }
    roomDimLabelData = {};
    roomDimGroup = new THREE.Group();

    var w = mm(room.widthMM), d = mm(room.depthMM);
    var y = mm(20);
    // Separación respecto a la pared. Con 250 mm la cota quedaba pegada al muro y
    // se leía como parte de la sala; 600 la despega lo justo para que se entienda
    // que es una referencia EXTERIOR, sin salirse del encuadre.
    var outset = mm(600);
    var tickHalf = mm(40);
    // Gris claro, no el gris tinta de la sala: es una referencia de fondo que está
    // permanentemente en pantalla, así que no debe competir con el producto.
    var mat = new THREE.LineBasicMaterial({ color: ROOM_DIM_LINE_HEX });

    function roomSeg(p1, p2, tickDir, labelId, text) {
      roomDimGroup.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([p1, p2]), mat));
      [p1, p2].forEach(function (p) {
        roomDimGroup.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([p.clone().sub(tickDir), p.clone().add(tickDir)]), mat));
      });
      roomDimLabelData[labelId] = { pos: p1.clone().lerp(p2, 0.5), text: text, cls: 'dim-label--room' };
    }

    // El rótulo lleva la MAGNITUD delante del número — es literalmente lo que se
    // pide: sin la palabra no se sabe si 600 cm es el ancho o el fondo.
    //
    // ⚠️ LADO en el que se dibuja cada cota: va en los bordes MÁS CERCANOS a la
    // cámara (frontal para el ancho, derecho para el fondo), no en los lejanos.
    // La pose por defecto (roomHomePose) mira desde +X/+Z, así que una cota en el
    // borde trasero o izquierdo se proyecta DETRÁS de las estanterías y se lee
    // como un pegote encima del producto — era el defecto que reportó el usuario.
    // En los bordes cercanos cae sobre suelo vacío en primer plano, que es donde
    // la pone un plano de arquitecto.
    roomSeg(
      new THREE.Vector3(-w / 2, y, d + outset), new THREE.Vector3(w / 2, y, d + outset),
      new THREE.Vector3(0, 0, tickHalf), 'dim-room-w',
      t('dim_ancho') + ' ' + (room.widthMM / 10) + ' cm'
    );
    roomSeg(
      new THREE.Vector3(w / 2 + outset, y, 0), new THREE.Vector3(w / 2 + outset, y, d),
      new THREE.Vector3(tickHalf, 0, 0), 'dim-room-d',
      t('dim_fondo') + ' ' + (room.depthMM / 10) + ' cm'
    );

    scene.add(roomDimGroup);
  }
  function updateDimLinesForSelection() {
    clearDimLines();
    var item = selectedItemId != null ? getItem(selectedItemId) : null;
    if (!item || !item.group) return;
    dimLinesGroup = new THREE.Group();
    var r = itemRectMM(item);
    var y = mm(Math.min(item.footprint.height, room.heightMM)) * 0.5;
    var midX = (r.x0 + r.x1) / 2, midZ = (r.z0 + r.z1) / 2;
    var c = computeClearances(item);

    // Código de color (idéntico en 3D, planta y PDF — ver leyenda):
    //   AZUL   producto ↔ pared   ·   NARANJA   producto ↔ producto
    // Con terminadores perpendiculares en ambos extremos (estilo plano) para
    // que se VEA entre qué dos bordes mide cada número. Solo se oculta el
    // hueco realmente nulo (contiguas por diseño); separaciones reales se
    // muestran con mínimo 1 cm.
    var DIM_COLOR_WALL = 0x2563EB, DIM_COLOR_ITEM = 0xF24507;
    var tickHalf = mm(45); // medio-tick ≈ 4,5cm de mundo
    function seg(mm1, mm2, isAlongX, fixedMM, labelId, valueMM, colorHex, cls) {
      if (valueMM < 1) return;
      var p1, p2;
      if (isAlongX) { p1 = new THREE.Vector3(mm(mm1 - room.widthMM / 2), y, mm(fixedMM)); p2 = new THREE.Vector3(mm(mm2 - room.widthMM / 2), y, mm(fixedMM)); }
      else { p1 = new THREE.Vector3(mm(fixedMM - room.widthMM / 2), y, mm(mm1)); p2 = new THREE.Vector3(mm(fixedMM - room.widthMM / 2), y, mm(mm2)); }
      var mat = new THREE.LineBasicMaterial({ color: colorHex });
      dimLinesGroup.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([p1, p2]), mat));
      // Terminadores: pequeña línea perpendicular en cada extremo
      var tickDir = isAlongX ? new THREE.Vector3(0, 0, tickHalf) : new THREE.Vector3(tickHalf, 0, 0);
      [p1, p2].forEach(function (p) {
        dimLinesGroup.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints([p.clone().sub(tickDir), p.clone().add(tickDir)]), mat));
      });
      dimLabelData[labelId] = { pos: p1.clone().lerp(p2, 0.5), text: Math.max(1, Math.round(valueMM / 10)) + ' cm', cls: cls };
    }
    seg(0, r.z0, false, midX, 'dim-back', c.toBack, DIM_COLOR_WALL, 'dim-label--wall');
    seg(r.z1, room.depthMM, false, midX, 'dim-front', c.toFront, DIM_COLOR_WALL, 'dim-label--wall');
    seg(0, r.x0, true, midZ, 'dim-left', c.toLeft, DIM_COLOR_WALL, 'dim-label--wall');
    seg(r.x1, room.widthMM, true, midZ, 'dim-right', c.toRight, DIM_COLOR_WALL, 'dim-label--wall');
    if (c.neighborLeft) seg(r.x0 - c.neighborLeft.gap, r.x0, true, midZ, 'dim-nbL', c.neighborLeft.gap, DIM_COLOR_ITEM, 'dim-label--item');
    if (c.neighborRight) seg(r.x1, r.x1 + c.neighborRight.gap, true, midZ, 'dim-nbR', c.neighborRight.gap, DIM_COLOR_ITEM, 'dim-label--item');
    if (c.neighborBack) seg(r.z0 - c.neighborBack.gap, r.z0, false, midX, 'dim-nbB', c.neighborBack.gap, DIM_COLOR_ITEM, 'dim-label--item');
    if (c.neighborFront) seg(r.z1, r.z1 + c.neighborFront.gap, false, midX, 'dim-nbF', c.neighborFront.gap, DIM_COLOR_ITEM, 'dim-label--item');
    scene.add(dimLinesGroup);
  }
  function updateDimLabelPositions() {
    if (viewMode !== 'orbit') {
      // En planta las cotas van dibujadas en el canvas 2D: se ocultan TODAS las
      // etiquetas HTML, también las permanentes de la sala.
      hideDimLabels(DIM_LABEL_IDS); hideDimLabels(ROOM_DIM_IDS);
      return;
    }
    projectDimLabels(DIM_LABEL_IDS, dimLabelData);
    projectDimLabels(ROOM_DIM_IDS, roomDimLabelData);
  }
  function hideDimLabels(ids) {
    ids.forEach(function (id) { var el = document.getElementById(id); if (el) el.style.display = 'none'; });
  }
  function projectDimLabels(ids, data) {
    var cw = renderer.domElement.clientWidth, chh = renderer.domElement.clientHeight;
    ids.forEach(function (id) {
      var el = document.getElementById(id); if (!el) return;
      var d = data[id];
      if (!d) { el.style.display = 'none'; return; }
      var proj = d.pos.clone().project(camera);
      if (proj.z > 1 || proj.z < -1) { el.style.display = 'none'; return; }
      el.style.display = 'block';
      el.className = 'dim-label ' + (d.cls || '');
      el.textContent = d.text;
      // La etiqueta se centra en su punto (transform: translate(-50%,-50%)), así que
      // un punto pegado al borde deja media etiqueta FUERA del visor y el texto se
      // corta. Pasó de verdad con la cota de fondo, que va en el borde derecho: se
      // leía "Tiefe 400" sin el "cm". Se mete dentro dejando su media anchura de
      // margen — la línea de cota sigue en su sitio, solo se reajusta el rótulo.
      var mw = el.offsetWidth / 2 + 2, mh = el.offsetHeight / 2 + 2;
      var x = (proj.x * 0.5 + 0.5) * cw;
      var y = (1 - (proj.y * 0.5 + 0.5)) * chh;
      el.style.left = clamp(x, mw, Math.max(mw, cw - mw)) + 'px';
      el.style.top = clamp(y, mh, Math.max(mh, chh - mh)) + 'px';
    });
  }

  function drawFloorPlan(canvas) {
    if (!canvas) return;
    var wrap = canvas.parentElement;
    var cssW = wrap.clientWidth || 600, cssH = wrap.clientHeight || 400;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = cssW * dpr; canvas.height = cssH * dpr;
    canvas.style.width = cssW + 'px'; canvas.style.height = cssH + 'px';
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cssW, cssH);

    var margin = 46;
    var scale = Math.max(0.001, Math.min((cssW - margin * 2) / room.widthMM, (cssH - margin * 2) / room.depthMM));
    var offX = (cssW - room.widthMM * scale) / 2, offY = (cssH - room.depthMM * scale) / 2;
    function px(v) { return offX + v * scale; }
    function py(v) { return offY + v * scale; }
    // offX/offY/scale están en espacio CSS-px (antes del setTransform de dpr) —
    // exactamente lo que necesita el hit-test inverso y el posicionamiento HTML
    // de la toolbar flotante sobre el canvas 2D. Solo para el canvas real e
    // interactivo (no el temporal que genera el PDF).
    if (canvas.id === 'plan-canvas') planViewTransform = { offX: offX, offY: offY, scale: scale };

    ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, cssW, cssH);
    ctx.fillStyle = '#FFFFFF'; ctx.fillRect(px(0), py(0), room.widthMM * scale, room.depthMM * scale);
    ctx.strokeStyle = '#EBEBEB'; ctx.lineWidth = 1;
    for (var gx = 0; gx <= room.widthMM; gx += 1000) { ctx.beginPath(); ctx.moveTo(px(gx), py(0)); ctx.lineTo(px(gx), py(room.depthMM)); ctx.stroke(); }
    for (var gz = 0; gz <= room.depthMM; gz += 1000) { ctx.beginPath(); ctx.moveTo(px(0), py(gz)); ctx.lineTo(px(room.widthMM), py(gz)); ctx.stroke(); }
    ctx.strokeStyle = '#1A1A18'; ctx.lineWidth = 3;
    ctx.strokeRect(px(0), py(0), room.widthMM * scale, room.depthMM * scale);

    items.forEach(function (it) {
      var r = itemRectMM(it);
      ctx.fillStyle = it.overlap ? '#FCA5A5' : (it.id === selectedItemId ? '#FDE0C8' : '#BFDBFE');
      ctx.strokeStyle = it.id === selectedItemId ? '#F24507' : '#1E3A8A';
      ctx.lineWidth = it.id === selectedItemId ? 2.5 : 1.25;
      ctx.fillRect(px(r.x0), py(r.z0), (r.x1 - r.x0) * scale, (r.z1 - r.z0) * scale);
      ctx.strokeRect(px(r.x0), py(r.z0), (r.x1 - r.x0) * scale, (r.z1 - r.z0) * scale);
      // Marca de frente: pequeña línea saliendo de la cara accesible (rotationDeg 0=+Z,90=+X,180=-Z,270=-X).
      var cx = (r.x0 + r.x1) / 2, cz = (r.z0 + r.z1) / 2, rot = ((it.rotationDeg || 0) % 360 + 360) % 360;
      var fx = cx + (rot === 90 ? 1 : rot === 270 ? -1 : 0) * 1, fz = cz + (rot === 0 ? 1 : rot === 180 ? -1 : 0) * 1;
      var dirX = rot === 90 ? (r.x1 - cx) : rot === 270 ? (r.x0 - cx) : 0;
      var dirZ = rot === 0 ? (r.z1 - cz) : rot === 180 ? (r.z0 - cz) : 0;
      ctx.strokeStyle = '#1E3A8A'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(px(cx), py(cz)); ctx.lineTo(px(cx + dirX * 0.35), py(cz + dirZ * 0.35)); ctx.stroke();
    });

    drawAllClearances(ctx, px, py);

    // Con la MAGNITUD delante: los dos números de la sala no se distinguían
    // ("600 cm" arriba y "400 cm" al lado no dicen cuál es ancho y cuál fondo).
    ctx.fillStyle = PLAN_COLOR_ROOM; ctx.font = '600 12px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
    ctx.fillText(t('dim_ancho') + ' ' + (room.widthMM / 10) + ' cm', (px(0) + px(room.widthMM)) / 2, py(0) - 8);
    ctx.save(); ctx.translate(px(0) - 8, (py(0) + py(room.depthMM)) / 2); ctx.rotate(-Math.PI / 2); ctx.fillText(t('dim_fondo') + ' ' + (room.depthMM / 10) + ' cm', 0, 0); ctx.restore();

    drawPlanLegend(ctx, cssW);
  }

  // Colores de cota (los mismos que en 3D y la leyenda): azul = a pared,
  // naranja = entre productos, gris tinta = dimensiones de la sala.
  var PLAN_COLOR_WALL = '#2563EB', PLAN_COLOR_ITEM = '#F24507', PLAN_COLOR_ROOM = '#1A1A18';
  // Mismo gris tinta en hexadecimal, para el contorno de la sala en la planta 2D.
  var PLAN_COLOR_ROOM_HEX = 0x1A1A18;
  // Las líneas 3D de las cotas de sala van MÁS CLARAS que ese gris tinta: están
  // permanentemente en pantalla, así que en negro competían con el producto. En la
  // planta 2D no hace falta aclararlas (ahí el dibujo es plano y no hay estanterías
  // que tapar), por eso son dos constantes y no una.
  var ROOM_DIM_LINE_HEX = 0xC9C9C9;

  function drawAllClearances(ctx, px, py) {
    ctx.font = '10px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    // Solo se oculta el hueco realmente nulo (0 mm exacto — contiguas por
    // diseño). Cualquier separación real se acota desde el final físico de
    // una estantería hasta el final de la otra, con un mínimo de 1 cm.
    function tag(mm1, mm2, isAlongX, fixed, color) {
      var val = Math.abs(mm2 - mm1);
      if (val < 1) return;
      var midMM = (mm1 + mm2) / 2;
      var x = isAlongX ? px(midMM) : px(fixed), y = isAlongX ? py(fixed) : py(midMM);
      ctx.strokeStyle = color; ctx.lineWidth = 1;
      ctx.beginPath();
      if (isAlongX) { ctx.moveTo(px(mm1), py(fixed)); ctx.lineTo(px(mm2), py(fixed)); } else { ctx.moveTo(px(fixed), py(mm1)); ctx.lineTo(px(fixed), py(mm2)); }
      ctx.stroke();
      // Terminadores perpendiculares en ambos extremos: se ve entre qué bordes se mide
      var t = 4;
      ctx.beginPath();
      if (isAlongX) {
        ctx.moveTo(px(mm1), py(fixed) - t); ctx.lineTo(px(mm1), py(fixed) + t);
        ctx.moveTo(px(mm2), py(fixed) - t); ctx.lineTo(px(mm2), py(fixed) + t);
      } else {
        ctx.moveTo(px(fixed) - t, py(mm1)); ctx.lineTo(px(fixed) + t, py(mm1));
        ctx.moveTo(px(fixed) - t, py(mm2)); ctx.lineTo(px(fixed) + t, py(mm2));
      }
      ctx.stroke();
      var txt = Math.max(1, Math.round(val / 10)) + '';
      var w = ctx.measureText(txt).width + 8;
      ctx.fillStyle = 'rgba(255,255,255,0.92)'; ctx.fillRect(x - w / 2, y - 7, w, 14);
      ctx.fillStyle = color; ctx.fillText(txt, x, y + 1);
    }
    items.forEach(function (it) {
      var r = itemRectMM(it), c = computeClearances(it);
      var midX = (r.x0 + r.x1) / 2, midZ = (r.z0 + r.z1) / 2;
      // A pared: solo la MÁS CERCANA en cada eje (todas las cotas a las 4
      // paredes de todos los productos convertían el plano en ruido ilegible).
      if (c.toBack <= c.toFront) tag(0, r.z0, false, midX, PLAN_COLOR_WALL); else tag(r.z1, room.depthMM, false, midX, PLAN_COLOR_WALL);
      if (c.toLeft <= c.toRight) tag(0, r.x0, true, midZ, PLAN_COLOR_WALL); else tag(r.x1, room.widthMM, true, midZ, PLAN_COLOR_WALL);
      // Entre productos (una vez por par: solo derecha/frente)
      if (c.neighborRight) tag(r.x1, r.x1 + c.neighborRight.gap, true, midZ, PLAN_COLOR_ITEM);
      if (c.neighborFront) tag(r.z1, r.z1 + c.neighborFront.gap, false, midX, PLAN_COLOR_ITEM);
    });
  }

  // Leyenda de colores dibujada en el propio canvas (visible también en el PDF).
  function drawPlanLegend(ctx, cssW) {
    var entries = [
      { color: PLAN_COLOR_WALL, label: t('legend_wall') + ' (cm)' },
      { color: PLAN_COLOR_ITEM, label: t('legend_item') + ' (cm)' },
      { color: PLAN_COLOR_ROOM, label: t('legend_room') + ' (cm)' }
    ];
    ctx.font = '10px Arial, sans-serif'; ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    // El ancho de la caja se MIDE del texto ya traducido: con 172px fijos, un
    // idioma más largo que el castellano se salía de la leyenda.
    var rowH = 16, pad = 8;
    var textW = 0;
    entries.forEach(function (e) { var m = ctx.measureText(e.label).width; if (m > textW) textW = m; });
    var boxW = Math.max(172, Math.ceil(textW) + pad * 2 + 24 + 6);
    var x0 = cssW - boxW - 8, y0 = 8;
    ctx.fillStyle = 'rgba(255,255,255,0.94)';
    ctx.strokeStyle = '#EBEBEB'; ctx.lineWidth = 1;
    ctx.fillRect(x0, y0, boxW, rowH * entries.length + pad * 2 - 6);
    ctx.strokeRect(x0, y0, boxW, rowH * entries.length + pad * 2 - 6);
    entries.forEach(function (e, i) {
      var yy = y0 + pad + i * rowH + 3;
      ctx.strokeStyle = e.color; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(x0 + pad, yy); ctx.lineTo(x0 + pad + 18, yy); ctx.stroke();
      ctx.fillStyle = '#1A1A18'; ctx.fillText(e.label, x0 + pad + 24, yy);
    });
  }
  function setCameraPreset(name) {
    var w = mm(room.widthMM), d = mm(room.depthMM), h = mm(room.heightMM);
    var reach = Math.max(w, d);
    if (name === 'top') { if (viewMode !== 'plan') toggleViewMode(); return; }
    ensurePerspective();
    var cy = h * 0.5, cz = d / 2;
    if (name === 'front') { animateCameraTo(new THREE.Vector3(0, cy, d + reach * 0.9 + 1), new THREE.Vector3(0, cy, cz)); }
    else if (name === 'side') { animateCameraTo(new THREE.Vector3(reach * 0.9 + 1, cy, cz), new THREE.Vector3(0, cy, cz)); }
    else { var home = roomHomePose(); animateCameraTo(home.pos, home.look); } // 'iso' / desconocido → encuadre isométrico por defecto (botón Reset)
  }
  function fitAllItems() {
    ensurePerspective();
    if (!items.length) { var home0 = roomHomePose(); animateCameraTo(home0.pos, home0.look); return; }
    var box = new THREE.Box3();
    items.forEach(function (it) { if (it.group) box.union(new THREE.Box3().setFromObject(it.group)); });
    if (box.isEmpty()) { var home1 = roomHomePose(); animateCameraTo(home1.pos, home1.look); return; }
    var center = box.getCenter(new THREE.Vector3()), size = box.getSize(new THREE.Vector3());
    var reach = Math.max(size.x, size.z, 0.5);
    var targetPos = new THREE.Vector3(center.x + reach * 0.9 + 1, center.y + reach * 0.7 + 1, center.z + reach * 0.9 + 1);
    animateCameraTo(targetPos, center);
  }

  function animate() {
    requestAnimationFrame(animate);
    controls.update();
    renderer.render(scene, camera);
    updateToolbarPosition();
    updateDimLabelPositions();
  }

  function onResize() {
    var canvas = document.getElementById('configurator-canvas'); if (!canvas) return;
    var viewerEl = canvas.parentElement;
    requestAnimationFrame(function () {
      var w = canvas.clientWidth || viewerEl.offsetWidth, h = canvas.clientHeight || viewerEl.offsetHeight;
      if (!w || !h) return;
      perspCam.aspect = w / h; perspCam.updateProjectionMatrix();
      renderer.setSize(w, h, false);
      if (viewMode === 'plan') { var pc = document.getElementById('plan-canvas'); if (pc) drawFloorPlan(pc); }
    });
  }

  // ─── Precios: resolución cross-market por SKU (idéntica en las 3 gamas de
  // origen — generalizada aquí en una sola implementación parametrizada por
  // gama). Ver memoria de proyecto: NO usar /es-es/ fijo (404 en no-ES); se
  // resuelve SIEMPRE en el mercado del visitante, con fallback a búsqueda
  // local por SKU (language-neutral) cuando el handle traducido no existe. ──
  function shopRoot() {
    try { var r = window.Shopify && Shopify.routes && Shopify.routes.root; return (r && typeof r === 'string') ? r : '/'; }
    catch (e) { return '/'; }
  }
  function isEsMarket() { var r = shopRoot(); return r === '/' || /^\/es(\/|-|$)/.test(r); }
  function buildInfo(d) {
    var v = d && d.variants && d.variants[0]; if (!v) return null;
    return {
      price: v.price || 0,
      compareAt: (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0,
      variantId: parseInt(v.id, 10), available: v.available !== false, title: d.title || ''
    };
  }
  function priceKey(item) { return item.gamaId + '|' + JSON.stringify(item.cfg); }
  function configsEqual(a, b) { return JSON.stringify(a) === JSON.stringify(b); }

  function resolveLocalBySku(gama, cfg, key, cb) {
    var sku = gama.deriveSku(cfg);
    if (!sku) { cb(null); return; }
    var root = shopRoot();
    var queries = gama.searchQueries(cfg);
    var seen = {};
    function finish(info) { if (info) priceCache[key] = info; cb(info || null); }
    function tryQuery(qi) {
      if (qi >= queries.length) { finish(null); return; }
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(queries[qi]) + '&resources[type]=product&resources[limit]=10')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (s) {
          var prods = (s && s.resources && s.resources.results && s.resources.results.products) || [];
          var cands = [];
          prods.forEach(function (p) { if (p && p.handle && !seen[p.handle]) { seen[p.handle] = 1; cands.push(p.handle); } });
          if (!cands.length) { tryQuery(qi + 1); return; }
          var pending = cands.length, done = false;
          cands.forEach(function (h) {
            fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
              if (done) return;
              var v = d && d.variants && d.variants[0];
              if (v && v.sku === sku) { done = true; finish(buildInfo(d)); return; }
              if (--pending === 0) tryQuery(qi + 1);
            }).catch(function () { if (!done && --pending === 0) tryQuery(qi + 1); });
          });
        }).catch(function () { tryQuery(qi + 1); });
    }
    tryQuery(0);
  }

  function getPriceFor(item, cb) {
    var gama = SpaceCatalog.GAMAS[item.gamaId];
    var key = priceKey(item);
    if (priceCache[key]) { cb(priceCache[key]); return; }
    if (!window.Shopify) { cb(null); return; } // standalone dev sin Shopify: sin precio real
    // Fuera de ES el handle español no existe (traducido, mercado ES en draft): pedirlo solo
    // deja un 404 en el rastreo de Google. Se resuelve por SKU directo, como tras ese 404.
    if (!isEsMarket()) { resolveLocalBySku(gama, item.cfg, key, cb); return; }
    var handle = gama.buildHandle(item.cfg);
    fetch(shopRoot() + 'products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (d) { var info = buildInfo(d); if (!info) throw new Error('novariant'); priceCache[key] = info; cb(info); })
      .catch(function () { resolveLocalBySku(gama, item.cfg, key, cb); });
  }

  function groupItems() {
    var groups = [];
    items.forEach(function (it) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].gamaId === it.gamaId && configsEqual(groups[i].cfg, it.cfg)) { groups[i].count++; groups[i].items.push(it); return; }
      }
      groups.push({ gamaId: it.gamaId, cfg: it.cfg, count: 1, items: [it] });
    });
    return groups;
  }

  function refreshPricesAndTotals() {
    var groups = groupItems();
    if (!groups.length) { renderItemsListUI(); return; }
    groups.forEach(function (g) { getPriceFor(g.items[0], function () { renderItemsListUI(); }); });
    renderItemsListUI();
  }

  function resolveAllPrices(cb) {
    var groups = groupItems();
    var pending = groups.length;
    if (!pending) { cb(); return; }
    groups.forEach(function (g) { getPriceFor(g.items[0], function () { if (--pending <= 0) cb(); }); });
  }

  // ─── UTM + compartir configuración (mismo patrón que los configuradores de producto) ──
  function getUtm() {
    var d = window.SpaceConfiguratorData;
    var u = (d && d.utm) ? d.utm : {};
    return {
      source:   u.source   || 'configurador-espacios',
      medium:   u.medium   || 'referral',
      campaign: u.campaign || 'planificador-almacen',
      content:  u.content  || '',
      term:     u.term     || ''
    };
  }

  function addUtmParams(url) {
    var utm = getUtm();
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var qs  = 'utm_source='   + encodeURIComponent(utm.source)   +
              '&utm_medium='  + encodeURIComponent(utm.medium)   +
              '&utm_campaign='+ encodeURIComponent(utm.campaign);
    if (utm.content) qs += '&utm_content=' + encodeURIComponent(utm.content);
    if (utm.term)    qs += '&utm_term='    + encodeURIComponent(utm.term);
    return url + sep + qs;
  }

  // ─── Estado compartible en la URL ──────────────────────────────────────────
  // El formato v1 metía el JSON completo de CADA unidad, con los nombres largos de
  // los campos repetidos una vez por unidad: una distribución de 21 estanterías daba
  // una URL de ~5.000 caracteres, ilegible al compartirla y monstruosa impresa en el
  // PDF. El formato v2 aprovecha que una distribución tiene MUCHAS unidades pero MUY
  // POCAS configuraciones distintas: agrupa por configuración, escribe cada una una
  // sola vez, y detrás solo la lista de posiciones. Además usa un formato delimitado
  // (sin comillas ni llaves de JSON) y los valores en el orden que declara `fields[]`
  // de la gama, así que tampoco viajan los nombres de los campos.
  //
  //   c=2|600.400.270|gama:v1,v2,v3…:x.z.r,x.z.r,…|gama:…
  //
  // Se lee TAMBIÉN el `?p=` antiguo, para que los enlaces ya compartidos sigan
  // funcionando (readShareConfig prueba primero v2 y luego v1).
  var SHARE_V = '2';
  function cfgFieldKeys(gama) {
    return (gama.fields || []).map(function (f) { return f.key; });
  }
  function encodeShareCompact() {
    var groups = [], byKey = {};
    items.forEach(function (it) {
      var k = it.gamaId + '|' + JSON.stringify(it.cfg);
      if (!byKey[k]) { byKey[k] = { gamaId: it.gamaId, cfg: it.cfg, pos: [] }; groups.push(byKey[k]); }
      byKey[k].pos.push(Math.round(it.xMM) + '.' + Math.round(it.zMM) + '.' + (normRot(it.rotationDeg)));
    });
    var partes = [SHARE_V, [Math.round(room.widthMM / 10), Math.round(room.depthMM / 10), Math.round(room.heightMM / 10)].join('.')];
    groups.forEach(function (g) {
      var gama = SpaceCatalog.GAMAS[g.gamaId];
      // Valores en el orden de fields[]: el decodificador los vuelve a casar con sus
      // claves leyendo el MISMO catálogo, así que no hace falta transportar nombres.
      var vals = cfgFieldKeys(gama).map(function (k) {
        var v = g.cfg[k];
        return (v === undefined || v === null) ? '' : String(v);
      });
      partes.push(g.gamaId + ':' + vals.join(',') + ':' + g.pos.join(','));
    });
    return partes.join('|');
  }
  // Formato v1 (JSON) — se mantiene solo para poder LEER enlaces antiguos.
  function decodeShareV1(raw) {
    var parsed; try { parsed = JSON.parse(raw); } catch (e) { return null; }
    if (!parsed || typeof parsed !== 'object') return null;
    var w = Number(parsed.w), d = Number(parsed.d), h = Number(parsed.h);
    if (!w || !d || !h) return null;
    var out = [];
    (Array.isArray(parsed.i) ? parsed.i : []).forEach(function (it) {
      if (!it || !SpaceCatalog.GAMAS[it.g] || !it.c || typeof it.c !== 'object') return;
      out.push({ g: it.g, c: it.c, x: Number(it.x) || 0, z: Number(it.z) || 0, r: Number(it.r) || 0 });
    });
    return { room: { w: w, d: d, h: h }, items: out };
  }
  function decodeShareV2(raw) {
    var partes = String(raw).split('|');
    if (partes.length < 2 || partes[0] !== SHARE_V) return null;
    var dims = partes[1].split('.');
    var w = Number(dims[0]) * 10, d = Number(dims[1]) * 10, h = Number(dims[2]) * 10;
    if (!w || !d || !h) return null;
    var out = [];
    for (var p = 2; p < partes.length; p++) {
      var trozos = partes[p].split(':');
      if (trozos.length < 3) continue;
      var gama = SpaceCatalog.GAMAS[trozos[0]];
      if (!gama) continue;                       // gama desconocida: se ignora ese grupo
      var keys = cfgFieldKeys(gama), vals = trozos[1].split(',');
      // ⚠️ Se parte de defaultConfig() y se sobreescriben valores, NO se construye un
      // objeto vacío recorriendo fields[]. Dos motivos, y el primero es un bug real:
      //  1. `priceKey()` y `groupItems()` comparan configs con JSON.stringify, que es
      //     SENSIBLE AL ORDEN DE LAS CLAVES. Si el decodificador las inserta en el
      //     orden de fields[] y defaultConfig() usa otro, un ítem restaurado desde un
      //     enlace NO agrupa con uno idéntico añadido a mano: se pediría su precio dos
      //     veces y saldría como dos líneas distintas en el carrito.
      //  2. Rellena por defecto cualquier campo que el enlace no traiga (enlace viejo,
      //     o un campo añadido al catálogo después de generarse el enlace).
      var cfg = gama.defaultConfig();
      for (var k = 0; k < keys.length; k++) {
        var v = vals[k];
        if (v === undefined || v === '') continue;
        // `niveles` es numérico en toda la app; el resto viaja como cadena.
        cfg[keys[k]] = (keys[k] === 'niveles') ? (parseInt(v, 10) || 0) : v;
      }
      trozos[2].split(',').forEach(function (posStr) {
        var q = posStr.split('.');
        if (q.length < 2) return;
        out.push({ g: trozos[0], c: cfg, x: Number(q[0]) || 0, z: Number(q[1]) || 0, r: Number(q[2]) || 0 });
      });
    }
    return { room: { w: w, d: d, h: h }, items: out };
  }

  function buildShareUrl() {
    var base = window.location.origin + window.location.pathname + '?c=' + encodeURIComponent(encodeShareCompact());
    return addUtmParams(base);
  }

  // Devuelve {room:{w,d,h}, items:[{g,c,x,z,r}]} o null. Nunca lanza: un enlace
  // corrupto o truncado simplemente no restaura nada y la página carga normal.
  function readShareConfig() {
    if (!window.location.search) return null;
    var params; try { params = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var v2 = params.get('c');
    if (v2) { try { return decodeShareV2(v2); } catch (e) { return null; } }
    var v1 = params.get('p');
    if (v1) { try { return decodeShareV1(v1); } catch (e) { return null; } }
    return null;
  }

  function copyShareUrl() {
    var url = buildShareUrl();
    if (navigator.share) {
      navigator.share({ title: t('share_native_title'), text: t('share_native_text') + ' ', url: url }).catch(function () {});
      return;
    }
    showSharePanel(url);
  }

  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(ta); ta.focus(); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta); done();
  }

  function showSharePanel(url) {
    var existing = document.getElementById('sc-share-panel');
    if (existing) { existing.remove(); return; }
    var shortUrl = url.length > 60 ? url.substring(0, 57) + '…' : url;
    var waUrl    = 'https://wa.me/?text=' + encodeURIComponent(t('share_native_text') + ' ' + url);
    var emailUrl = 'mailto:?subject=' + encodeURIComponent(t('share_native_title')) + '&body=' + encodeURIComponent(t('share_native_text') + '\n' + url);
    var panel = document.createElement('div');
    panel.id = 'sc-share-panel'; panel.className = 'sc-share-panel';
    panel.innerHTML =
      '<div class="sc-share-panel__title">' + t('share_title') + '</div>' +
      '<div class="sc-share-panel__url">' + shortUrl + '</div>' +
      '<div class="sc-share-panel__btns">' +
        '<a href="' + waUrl + '" target="_blank" rel="noopener" class="sc-share-panel__btn sc-share-panel__btn--wa">' + t('share_wa') + '</a>' +
        '<a href="' + emailUrl + '" class="sc-share-panel__btn sc-share-panel__btn--email">' + t('share_email') + '</a>' +
        '<button type="button" class="sc-share-panel__btn sc-share-panel__btn--copy" id="sc-sp-copy"><span>' + t('share_copy') + '</span></button>' +
      '</div>';
    var shareBtnEl = document.getElementById('share-btn');
    if (shareBtnEl) {
      var r = shareBtnEl.getBoundingClientRect();
      panel.style.position = 'fixed'; panel.style.bottom = (window.innerHeight - r.top + 10) + 'px'; panel.style.right = (window.innerWidth - r.right) + 'px';
    } else { panel.style.position = 'fixed'; panel.style.bottom = '90px'; panel.style.right = '20px'; }
    document.body.appendChild(panel);
    var copyBtn = document.getElementById('sc-sp-copy');
    function doCopy() {
      function done() { copyBtn.querySelector('span').textContent = t('share_copied'); copyBtn.classList.add('sc-share-panel__btn--done'); setTimeout(function () { panel.remove(); }, 1400); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done).catch(function () { fallbackCopy(url, done); });
      else fallbackCopy(url, done);
    }
    copyBtn.addEventListener('click', doCopy);
    setTimeout(function () {
      document.addEventListener('click', function closePanel(e) {
        if (!panel.contains(e.target) && e.target.id !== 'share-btn') { panel.remove(); document.removeEventListener('click', closePanel); }
      });
    }, 50);
  }

  // Permalink de carrito multi-gama (una línea por grupo, cantidad = nº items).
  // A diferencia de buildCartPermalink() de los configuradores de producto,
  // EXCLUIMOS grupos sin stock (info.available === false) — igual que ya hace
  // addAllToCart() más abajo en este mismo archivo: un enlace de compra nunca
  // debe ofrecer algo sin stock. Usa shopRoot() (no solo '/') para que el link
  // funcione también en mercados con root de idioma propio.
  function buildCartPermalink() {
    var groups = groupItems();
    var parts = [];
    groups.forEach(function (g) {
      var info = priceCache[priceKey(g.items[0])];
      if (info && info.variantId && info.available !== false) parts.push(info.variantId + ':' + g.count);
    });
    if (!parts.length) return '';
    return window.location.origin + shopRoot() + 'cart/' + parts.join(',');
  }

  function buildContactMailto() {
    var data = window.SpaceConfiguratorData || {};
    var email = data.consultationEmail || 'hola@misterregale.com';
    var groups = groupItems();
    var roomLbl = (room.widthMM / 10) + ' × ' + (room.depthMM / 10) + ' × ' + (room.heightMM / 10) + ' cm';
    var subject = t('mail_subject').replace('{room}', roomLbl);
    var body = t('mail_greeting') + ',\n\n' + t('mail_intro') + '\n\n' + t('mail_room') + ': ' + roomLbl + '\n\n';
    if (!groups.length) {
      body += t('mail_none') + '\n';
    } else {
      groups.forEach(function (g) {
        var gama = SpaceCatalog.GAMAS[g.gamaId];
        body += '  • ' + g.count + '× ' + gama.summary(g.cfg, t) + '\n';
      });
      var total = groups.reduce(function (s, g) { var info = priceCache[priceKey(g.items[0])]; return s + (info ? (info.price / 100) * g.count : 0); }, 0);
      body += '\n' + t('mail_total') + ': ' + total.toFixed(2) + ' €\n';
    }
    body += '\n' + t('mail_link') + ' ' + buildShareUrl();
    body += '\n\n' + t('mail_thanks');
    return 'mailto:' + email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  // ─── Carrito multi-línea (una línea por grupo gama+config, cantidad = nº ítems) ──
  function addAllToCart() {
    var btn = document.getElementById('add-to-cart-btn'); if (!btn) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!items.length) { showToast(t('need_items_cart')); return; }

    if (!window.Shopify) {
      console.log('[SpaceConfigurator] Dev mode — grupos a añadir:', groupItems());
      showToast(t('dev_mode'));
      return;
    }

    btn.disabled = true; btn.textContent = t('adding');
    var groups = groupItems();
    var idx = 0, okCount = 0, stockSkipped = 0, otherErrors = 0;

    function finish() {
      btn.disabled = false;
      if (okCount > 0) {
        btn.textContent = stockSkipped ? t('added_partial').replace('{n}', stockSkipped) : t('added');
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-bubble__text-count').forEach(function (el) {
            el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none';
          });
          document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.remove('cart-bubble--hidden'); });
          var drawer = document.querySelector('#CartDrawer, cart-drawer');
          if (window.Theme && window.Theme.openCart) window.Theme.openCart();
          else if (drawer && typeof drawer.open === 'function') drawer.open();
        });
      } else {
        btn.textContent = stockSkipped ? t('no_stock') : t('cart_error');
      }
      setTimeout(function () { btn.textContent = t('add_all'); }, 2800);
    }
    function next() {
      if (idx >= groups.length) { finish(); return; }
      var g = groups[idx++];
      getPriceFor(g.items[0], function (info) {
        if (info && info.variantId && info.available !== false) {
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: parseInt(info.variantId, 10), quantity: g.count })
          }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || String(r.status)); }); })
            .then(function () { okCount++; next(); }).catch(function () { otherErrors++; next(); });
        } else {
          if (info && info.available === false) stockSkipped++; else otherErrors++;
          next(); // seguir con el resto de líneas — una sin stock no debe bloquear las demás
        }
      });
    }
    next();
  }

  // ─── Presupuesto: captura del canvas + BOM, impresión a PDF vía el navegador
  // (sin librería externa — mismo patrón "sin build tools" del resto del repo) ──
  function generateBudget() {
    var groups = groupItems();
    var rows = groups.map(function (g) {
      var gama = SpaceCatalog.GAMAS[g.gamaId];
      var info = priceCache[priceKey(g.items[0])];
      var unit = info ? (info.price / 100) : null;
      return { label: gama.summary(g.cfg, t), qty: g.count, unit: unit, total: unit != null ? unit * g.count : null };
    });
    var grandTotal = rows.reduce(function (s, r) { return s + (r.total || 0); }, 0);
    // Renderizar justo antes de capturar: preserveDrawingBuffer no está activo
    // (coste de memoria en cada frame) — el buffer puede llegar limpio si no se
    // repinta en el mismo tick que el toDataURL.
    renderer.render(scene, camera);
    var shot = renderer.domElement.toDataURL('image/png');
    var planCanvas = document.createElement('canvas');
    planCanvas.style.position = 'absolute'; planCanvas.style.width = '900px'; planCanvas.style.height = '600px';
    var fakeWrap = document.createElement('div'); fakeWrap.style.width = '900px'; fakeWrap.style.height = '600px';
    fakeWrap.appendChild(planCanvas); document.body.appendChild(fakeWrap);
    drawFloorPlan(planCanvas);
    var planShot = planCanvas.toDataURL('image/png');
    document.body.removeChild(fakeWrap);
    var cartUrlRaw = buildCartPermalink();
    var cartUrl = cartUrlRaw ? addUtmParams(cartUrlRaw) : '';
    var shareUrl = buildShareUrl(); // ya incluye UTM
    var win = window.open('', '_blank');
    if (!win) { showToast(t('popup_blocked')); return; }
    // Datos de cabecera: logo, referencia y fecha, como en el PDF de los
    // configuradores de producto (ese documento ya está resuelto y probado).
    var data = window.SpaceConfiguratorData || {};
    var logoUrl = data.logoUrl || '';
    var email = data.consultationEmail || 'hola@misterregale.com';
    var hoy = new Date();
    var dosCifras = function (n) { return (n < 10 ? '0' : '') + n; };
    var fechaStr = dosCifras(hoy.getDate()) + '/' + dosCifras(hoy.getMonth() + 1) + '/' + hoy.getFullYear();
    var refStr = 'MR-' + hoy.getFullYear() + dosCifras(hoy.getMonth() + 1) + dosCifras(hoy.getDate()) +
      '-' + dosCifras(hoy.getHours()) + dosCifras(hoy.getMinutes());
    var totalUnidades = items.length;
    var m2 = ((room.widthMM / 1000) * (room.depthMM / 1000)).toFixed(1);
    // Capacidad total: se suma en la unidad que declara cada gama, así que se
    // presentan por separado (metros de balda y palés no se pueden sumar juntos).
    var mBalda = 0, nPales = 0;
    groups.forEach(function (g) {
      var gama = SpaceCatalog.GAMAS[g.gamaId];
      if (typeof gama.capacity !== 'function') return;
      var cap; try { cap = gama.capacity(g.cfg); } catch (e) { return; }
      if (!cap) return;
      if (cap.unitKey === 'cap_unit_pallet' && cap.count) nPales += cap.count * g.count;
      else mBalda += (shelfWidthMM(gama, g.cfg) / 1000) * (parseInt(g.cfg.niveles, 10) || 0) * g.count;
    });

    var html = '<!DOCTYPE html><html lang="' + ((window.Shopify && Shopify.locale) ? String(Shopify.locale).slice(0, 2) : 'es') + '">' +
      '<head><meta charset="utf-8"><title>' + t('pdf_doc_title') + '</title>' +
      '<style>' +
        '*{box-sizing:border-box;margin:0;padding:0}' +
        'body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;color:#1A1A18;background:#fff;font-size:12px;line-height:1.45}' +
        '.page{max-width:210mm;margin:0 auto;padding:12mm 12mm 8mm}' +
        /* Cabecera: logo a la izquierda, título + referencia a la derecha */
        '.hdr{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #F24507;padding-bottom:10px;margin-bottom:14px}' +
        '.hdr-logo{height:38px;object-fit:contain;display:block}' +
        '.hdr-brand{font-size:19px;font-weight:800;letter-spacing:-.01em}' +
        '.hdr-right{text-align:right}' +
        '.hdr-right h1{font-size:15px;font-weight:700}' +
        '.hdr-right .meta{font-size:10px;color:#8A8A85;margin-top:2px}' +
        /* Banda de datos del espacio: una fila de cifras clave */
        '.facts{display:flex;border:1px solid #E5E5E5;border-radius:4px;overflow:hidden;margin-bottom:14px}' +
        '.fact{flex:1;padding:8px 10px;border-right:1px solid #E5E5E5}' +
        '.fact:last-child{border-right:none}' +
        '.fact-l{display:block;font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#8A8A85;margin-bottom:2px}' +
        '.fact-v{display:block;font-size:14px;font-weight:800}' +
        /* Las dos vistas, en paralelo y a la misma altura */
        '.views{display:flex;gap:10px;margin-bottom:14px}' +
        '.view{flex:1;min-width:0}' +
        '.view h2{font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#8A8A85;margin-bottom:4px}' +
        '.view img{width:100%;height:auto;display:block;border:1px solid #E5E5E5;border-radius:3px}' +
        /* Tabla de material */
        'h2.sec{font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#8A8A85;margin-bottom:5px;padding-bottom:4px;border-bottom:1px solid #E5E5E5}' +
        'table{width:100%;border-collapse:collapse}' +
        'th{text-align:left;padding:5px 7px;font-size:8.5px;text-transform:uppercase;letter-spacing:.05em;color:#8A8A85;background:#FAFAFA;border-bottom:1px solid #E5E5E5}' +
        'td{padding:6px 7px;border-bottom:1px solid #F0F0F0;font-size:11.5px;vertical-align:top}' +
        'th.num,td.num{text-align:right;white-space:nowrap}' +
        /* Total */
        '.total{display:flex;justify-content:space-between;align-items:center;background:#1A1A18;color:#fff;border-radius:4px;padding:10px 14px;margin-top:12px}' +
        '.total .lbl{font-size:11px;opacity:.75}' +
        '.total .val{font-size:20px;font-weight:800}' +
        /* Compra */
        '.buy{display:flex;justify-content:space-between;align-items:center;gap:14px;background:#FAFAFA;border:1px solid #E5E5E5;border-radius:4px;padding:12px 14px;margin-top:12px}' +
        '.buy strong{font-size:12px;display:block}' +
        '.buy p{font-size:10.5px;color:#6b6b66;margin-top:2px}' +
        /* Solo el enlace HIJO DIRECTO es el botón. Con `.buy a` a secas, el enlace en
           línea del texto de abajo se pintaba también como botón negro y se solapaba
           con el de verdad. */
        '.buy > a{background:#1A1A18;color:#fff;padding:9px 18px;border-radius:3px;text-decoration:none;font-size:12px;font-weight:700;white-space:nowrap;flex-shrink:0}' +
        '.qr{font-size:9.5px;color:#8A8A85;margin-top:5px}' +
        '.qr a{color:#6b6b66;text-decoration:underline}' +
        '.footer{border-top:1px solid #E5E5E5;margin-top:14px;padding-top:8px;display:flex;justify-content:space-between;font-size:9.5px;color:#8A8A85}' +
        '.print-btn{position:fixed;top:16px;right:16px;background:#F24507;color:#fff;border:none;padding:9px 20px;border-radius:4px;font-size:13px;font-weight:700;cursor:pointer;box-shadow:0 3px 10px rgba(0,0,0,.22)}' +
        /* Al imprimir: fuera el botón y el enlace de compra (no se puede pulsar en papel), */
        /* y los colores planos se fuerzan para que la cabecera y el total no salgan en blanco. */
        '@media print{.print-btn,.buy > a{display:none!important}.page{padding:0}' +
          'body{print-color-adjust:exact;-webkit-print-color-adjust:exact}}' +
      '</style></head><body>' +
      '<button class="print-btn" onclick="window.print()">&#8595; ' + t('pdf_save') + '</button>' +
      '<div class="page">' +
        '<div class="hdr">' +
          (logoUrl ? '<img src="' + logoUrl + '" class="hdr-logo" alt="Master Rax">' : '<span class="hdr-brand">Master Rax</span>') +
          '<div class="hdr-right"><h1>' + t('pdf_doc_title') + '</h1>' +
            '<div class="meta">' + refStr + ' &nbsp;·&nbsp; ' + fechaStr + '</div></div>' +
        '</div>' +
        /* Cifras clave del espacio y de lo colocado */
        '<div class="facts">' +
          '<div class="fact"><span class="fact-l">' + t('dim_ancho') + '</span><span class="fact-v">' + (room.widthMM / 10) + ' cm</span></div>' +
          '<div class="fact"><span class="fact-l">' + t('dim_fondo') + '</span><span class="fact-v">' + (room.depthMM / 10) + ' cm</span></div>' +
          '<div class="fact"><span class="fact-l">' + t('dim_alto') + '</span><span class="fact-v">' + (room.heightMM / 10) + ' cm</span></div>' +
          '<div class="fact"><span class="fact-l">m&sup2;</span><span class="fact-v">' + m2 + '</span></div>' +
          '<div class="fact"><span class="fact-l">' + t('units_word') + '</span><span class="fact-v">' + totalUnidades + '</span></div>' +
          (nPales > 0
            ? '<div class="fact"><span class="fact-l">' + t('pales_word') + '</span><span class="fact-v">' + nPales + '</span></div>'
            : '<div class="fact"><span class="fact-l">m ' + t('cap_shelf_lbl') + '</span><span class="fact-v">' + mBalda.toFixed(1) + '</span></div>') +
        '</div>' +
        /* Las dos vistas en paralelo: en vertical ocupaban dos páginas */
        '<div class="views">' +
          '<div class="view"><h2>' + t('view_3d') + '</h2><img src="' + shot + '" alt=""></div>' +
          '<div class="view"><h2>' + t('pdf_plan_title') + '</h2><img src="' + planShot + '" alt=""></div>' +
        '</div>' +
        '<h2 class="sec">' + t('step_summary') + '</h2>' +
        '<table><thead><tr>' +
          '<th>' + t('pdf_col_product') + '</th>' +
          '<th class="num">' + t('pdf_col_qty') + '</th>' +
          '<th class="num">' + t('pdf_col_unit') + '</th>' +
          '<th class="num">' + t('pdf_col_total') + '</th>' +
        '</tr></thead><tbody>' +
        rows.map(function (r) {
          return '<tr><td>' + r.label + '</td>' +
            '<td class="num">' + r.qty + '</td>' +
            '<td class="num">' + (r.unit != null ? r.unit.toFixed(2) + ' €' : '—') + '</td>' +
            '<td class="num">' + (r.total != null ? r.total.toFixed(2) + ' €' : '—') + '</td></tr>';
        }).join('') +
        '</tbody></table>' +
        '<div class="total"><span class="lbl">' + t('pdf_total_est') + '</span><span class="val">' + grandTotal.toFixed(2) + ' €</span></div>' +
        '<div class="buy"><div>' +
          '<strong>' + (cartUrl ? t('pdf_buy_title_cart') : t('pdf_buy_title_share')) + '</strong>' +
          '<p>' + (cartUrl ? t('pdf_buy_text_cart') : t('pdf_buy_text_share')) + '</p>' +
          /* El enlace de configuración va SOLO como enlace del texto, no impreso en
             crudo: con muchas unidades ocupaba media página de caracteres. */
          (shareUrl ? '<div class="qr">' + t('mail_link') + ' <a href="' + shareUrl + '">' + t('pdf_view_config') + '</a></div>' : '') +
        '</div>' +
        (cartUrl ? '<a href="' + cartUrl + '">' + t('pdf_buy_now') + '</a>' : '<a href="' + shareUrl + '">' + t('pdf_view_config') + '</a>') +
        '</div>' +
        '<div class="footer"><span>Master Rax &nbsp;·&nbsp; ' + email + ' &nbsp;·&nbsp; www.misterregale.com</span>' +
          '<span>' + refStr + '</span></div>' +
      '</div>' +
      '<script>window.onload=function(){setTimeout(function(){window.print();},400);};<\/script></body></html>';
    win.document.write(html);
    win.document.close();
  }
  function prepareBudget() {
    if (!items.length) { showToast(t('need_items_pdf')); return; }
    resolveAllPrices(generateBudget);
  }

  // ─── UI: panel lateral por pasos (gama-agnóstico — lee SpaceCatalog.GAMAS) ──
  function renderGamaPicker() {
    var el = document.getElementById('gama-picker'); if (!el) return;
    var imgOverrides = (window.SpaceConfiguratorData && window.SpaceConfiguratorData.gamaImages) || {};
    el.innerHTML = '';
    SpaceCatalog.order.forEach(function (id) {
      var gama = SpaceCatalog.GAMAS[id];
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'gama-card' + (id === activeGamaId ? ' active' : '');
      var imgUrl = imgOverrides[id] || gama.image || '';
      var thumb = document.createElement('span'); thumb.className = 'gama-card__thumb';
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl; img.alt = gamaLabel(gama); img.loading = 'lazy';
        thumb.appendChild(img);
      }
      var txt = document.createElement('span'); txt.className = 'gama-card__text';
      var name = document.createElement('strong'); name.textContent = gamaLabel(gama);
      var desc = document.createElement('small'); desc.textContent = gamaUse(gama);
      txt.appendChild(name); txt.appendChild(desc);
      // Capacidad máxima de la gama (antes de elegir config). Degrada en
      // silencio si la gama todavía no declara capacityMax().
      var capTxt = gamaCapacityMax(gama);
      if (capTxt) {
        var cap = document.createElement('small'); cap.className = 'gama-card__cap'; cap.textContent = capTxt;
        txt.appendChild(cap);
      }
      btn.appendChild(thumb); btn.appendChild(txt);
      btn.addEventListener('click', function () {
        activeGamaId = id; activeCfg = gama.defaultConfig();
        nivelesTocados = false;
        adaptCfgToRoom(id);   // altura que quepa + pasillo mínimo de la gama
        renderGamaPicker(); renderProductFields();
      });
      el.appendChild(btn);
    });
  }

  // Renderiza el esquema de campos de una gama (selects normales + swatches de
  // color) dentro de `el`, leyendo valores de `cfg` y delegando cada cambio a
  // `onChange(key, rawValue)`. Comparten esta función tanto el panel de "nuevo
  // ítem" (3 · Medidas del producto) como el de edición del ítem seleccionado.
  // Etiquetas de campo y de valor: el catálogo declara el texto castellano como
  // respaldo y las claves i18n reutilizadas del namespace configurator.* se
  // mapean aquí por el NOMBRE del campo/valor (las gamas usan nombres distintos
  // para la misma magnitud: anchura/ancho, altura/alto, profundidad/fondo,
  // tipoBalda/tipo). Si el catálogo declara `f.labelKey`, esa gana.
  var FIELD_I18N = {
    anchura: 'f_anchura', ancho: 'f_anchura',
    altura: 'f_altura', alto: 'f_altura',
    profundidad: 'f_fondo', fondo: 'f_fondo',
    niveles: 'f_niveles',
    tipoBalda: 'f_tipo_balda', tipo: 'f_tipo_balda',
    color: 'f_color'
  };
  // Los VALORES se resuelven por nombre de opción (malla/madera/gris…), pero eso
  // solo vale cuando el nombre es único en todo el catálogo: 'no'/'si' significan
  // cosas distintas en el eje de la malla ("Sin balda") y en el del protector
  // ("No"), así que esos van declarados POR CAMPO en el catálogo (`f.labelKeys`),
  // que gana sobre este mapa.
  var VALUE_I18N = {
    malla: 'v_malla', madera: 'v_madera', metalica: 'v_metalica',
    aglomerado: 'v_aglomerado', gris: 'v_gris', anthrazita: 'v_anthrazita', bicolor: 'v_bicolor'
  };
  // t() devuelve el NOMBRE DE LA CLAVE cuando no la encuentra, así que hay que
  // comprobarlo antes de pintar: sin esto, una clave que el Liquid no emita se
  // vería en crudo en pantalla en vez de caer al castellano del catálogo (es
  // exactamente el fallo que se dio con `gama_bullrack_label`).
  function tOr(key, fallback) {
    if (!key) return fallback;
    var s = t(key);
    return (s && s !== key) ? s : fallback;
  }
  function fieldLabel(f) {
    return tOr(f.labelKey || FIELD_I18N[f.key], f.label || f.key);
  }
  function valueLabel(f, o) {
    // Valor NUMÉRICO con unidad (carga por palé): se compone el número con la
    // unidad ya traducida, para no necesitar una clave por cifra.
    if (f.valueSuffixKey) return o + ' ' + tOr(f.valueSuffixKey, '');
    var fb = (f.labels && f.labels[o]) ? f.labels[o] : String(o);
    return tOr((f.labelKeys && f.labelKeys[o]) || VALUE_I18N[o], fb);
  }

  function renderFieldsInto(el, gama, cfg, onChange) {
    el.innerHTML = '';
    gama.fields.forEach(function (f) {
      if (f.key === 'unitType' && !(gama.canUseUnitType)) return; // solo gamas con inicial/extensión
      var wrap = document.createElement('label'); wrap.className = 'field-row';
      var span = document.createElement('span'); span.textContent = fieldLabel(f) + (f.unit ? (' (' + f.unit + ')') : '');
      wrap.appendChild(span);
      var opts = f.dynamic ? gama.nivelesFor(cfg).map(String) : f.options;
      if (f.swatch) {
        var swWrap = document.createElement('div'); swWrap.className = 'swatch-row';
        opts.forEach(function (o) {
          var sw = document.createElement('button');
          sw.type = 'button';
          sw.className = 'swatch' + (String(cfg[f.key]) === String(o) ? ' active' : '');
          sw.style.background = (f.swatchColors && f.swatchColors[o]) || '#ccc';
          sw.title = valueLabel(f, o);
          sw.addEventListener('click', function () { onChange(f.key, o); });
          swWrap.appendChild(sw);
        });
        wrap.appendChild(swWrap);
      } else {
        var select = document.createElement('select'); select.dataset.key = f.key;
        // El campo de ALTURA marca y deshabilita las medidas que no caben en el
        // alto de tu espacio: es mejor que el usuario lo vea antes de elegir que
        // colocar un bastidor de 6 m en una nave de 2,70 y verlo salir del techo.
        var hField = heightFieldOf(gama.id);
        var isHeightField = !!(hField && hField.key === f.key);
        opts.forEach(function (o) {
          var opt = document.createElement('option');
          opt.value = o; opt.textContent = valueLabel(f, o);
          if (isHeightField && heightForOption(gama.id, f, o, cfg) > room.heightMM + 1) {
            opt.disabled = true;
            opt.textContent += ' — ' + t('fit_no_cabe');
          }
          if (String(cfg[f.key]) === String(o)) opt.selected = true;
          select.appendChild(opt);
        });
        select.addEventListener('change', function () { onChange(f.key, select.value); });
        wrap.appendChild(select);
      }
      el.appendChild(wrap);
    });
  }

  function renderProductFields() {
    var el = document.getElementById('product-fields'); if (!el || !activeGamaId) return;
    var gama = SpaceCatalog.GAMAS[activeGamaId];
    renderFieldsInto(el, gama, activeCfg, function (key, val) {
      // Tocar el selector de niveles es la señal de que ese número lo elige el
      // usuario ⇒ la «Distribución óptima» ya no lo maximiza (ver bestHeightAndLevels).
      if (key === 'niveles') nivelesTocados = true;
      activeCfg[key] = (key === 'niveles') ? parseInt(val, 10) : val;
      var validNiv = gama.nivelesFor(activeCfg).map(String);
      if (validNiv.indexOf(String(activeCfg.niveles)) === -1) activeCfg.niveles = parseInt(validNiv[0], 10);
      renderProductFields();
    });
  }

  // ─── Edición del ítem seleccionado (medidas/niveles/color/altura) — cambia
  // la config de una estantería YA colocada y recarga su modelo in situ. ──
  function updateSelectedItemConfig(key, rawValue) {
    var item = getItem(selectedItemId); if (!item) return;
    var gama = SpaceCatalog.GAMAS[item.gamaId];
    var newCfg = Object.assign({}, item.cfg);
    newCfg[key] = (key === 'niveles') ? parseInt(rawValue, 10) : rawValue;
    var validNiv = gama.nivelesFor(newCfg).map(String);
    if (validNiv.indexOf(String(newCfg.niveles)) === -1) newCfg.niveles = parseInt(validNiv[0], 10);
    if (newCfg.unitType && gama.canUseUnitType) {
      var others = items.filter(function (i) { return i.id !== item.id; });
      if (!gama.canUseUnitType(newCfg.unitType, newCfg, others)) {
        showToast(t('chain_cannot_switch'));
        return;
      }
    }
    item.cfg = newCfg;
    item.footprint = gama.footprintMM(newCfg);
    loadAndPlaceItem(item);
    refreshOverlapState();
    renderEditPanel();
    refreshPricesAndTotals();
    normalizeChainedUnitTypes(); redrawPlanIfActive(); // alto/fondo pueden romper la cadena de una Extensión vecina
  }

  function renderEditPanel() {
    var wrap = document.getElementById('edit-panel-wrap');
    var el = document.getElementById('edit-panel');
    if (!wrap || !el) return;
    var item = selectedItemId != null ? getItem(selectedItemId) : null;
    if (!item) { wrap.style.display = 'none'; el.innerHTML = ''; return; }
    wrap.style.display = '';
    var gama = SpaceCatalog.GAMAS[item.gamaId];
    renderFieldsInto(el, gama, item.cfg, updateSelectedItemConfig);
    // Capacidad de ESTA configuración concreta, delante de los campos. Contrato
    // del catálogo: gama.capacity(cfg) → { value, unitKey[, count, countUnitKey] }.
    // Si la gama todavía no lo declara, no se pinta nada (degrada en silencio).
    var capTxt = gamaCapacityOf(gama, item.cfg);
    if (capTxt) {
      var cap = document.createElement('p'); cap.className = 'edit-panel__cap'; cap.textContent = capTxt;
      el.insertBefore(cap, el.firstChild);
    }
  }

  function renderItemsListUI() {
    var el = document.getElementById('items-list');
    var groups = groupItems();
    if (el) {
      el.innerHTML = '';
      if (!groups.length) {
        var empty = document.createElement('p'); empty.className = 'items-empty';
        empty.textContent = t('items_empty');
        el.appendChild(empty);
      }
      groups.forEach(function (g) {
        var gama = SpaceCatalog.GAMAS[g.gamaId];
        var info = priceCache[priceKey(g.items[0])];
        var priceTxt = info ? (((info.price / 100) * g.count).toFixed(2) + ' €') : '…';
        var noStock = info && info.available === false;
        var row = document.createElement('div'); row.className = 'item-row' + (noStock ? ' item-row--nostock' : '');
        row.innerHTML = '<span class="item-row__label">' + g.count + '× ' + gama.summary(g.cfg, t) + (noStock ? ' <span class="item-row__badge">' + t('no_stock') + '</span>' : '') + '</span>' +
          '<span class="item-row__price">' + priceTxt + '</span>';
        el.appendChild(row);
      });
    }
    var totalEl = document.getElementById('items-total');
    if (totalEl) {
      var total = groups.reduce(function (s, g) { var info = priceCache[priceKey(g.items[0])]; return s + (info ? (info.price / 100) * g.count : 0); }, 0);
      totalEl.textContent = t('total_label') + ': ' + total.toFixed(2) + ' € · ' + items.length + ' ' + t('units_word');
    }
  }

  function bindRoomInputs() {
    var wI = document.getElementById('room-width'), dI = document.getElementById('room-depth'), hI = document.getElementById('room-height');
    if (wI) wI.value = room.widthMM / 10;
    if (dI) dI.value = room.depthMM / 10;
    if (hI) hI.value = room.heightMM / 10;
    var apply = document.getElementById('room-apply');
    if (apply) apply.addEventListener('click', function () {
      room.widthMM = clamp((parseFloat(wI.value) || 600) * 10, 1000, 100000);
      room.depthMM = clamp((parseFloat(dI.value) || 400) * 10, 1000, 100000);
      room.heightMM = clamp((parseFloat(hI.value) || 250) * 10, 1500, 20000);
      buildRoom();
      if (viewMode === 'orbit') { frameCameraToRoom(); } else { var pc = document.getElementById('plan-canvas'); if (pc) drawFloorPlan(pc); }
      refreshOverlapState();
      updateDimLinesForSelection();
      // Cambiar el ALTO de tu espacio cambia qué medidas caben, así que hay que
      // repintar los campos (las opciones que no caben se marcan y se deshabilitan)
      // y reencajar la config activa. Sin esto, el selector seguiría ofreciendo una
      // altura que acaba de dejar de caber.
      if (activeGamaId) { adaptCfgToRoom(activeGamaId); renderProductFields(); renderEditPanel(); }
    });
  }

  // Mapa patrón → clave i18n. La resolución va DENTRO de una función a propósito:
  // un `var PATTERN_LABELS = { rows: t('pattern_rows'), … }` de módulo se
  // evaluaría al cargar el archivo, antes de que exista SpaceConfiguratorData,
  // y congelaría el castellano de respaldo en todos los idiomas.
  var PATTERN_KEYS = { rows: 'pattern_rows', perimeter: 'pattern_perimeter', islands: 'pattern_islands', 'perimeter-islands': 'pattern_perimeter_islands' };
  function patternLabel(p) { var k = PATTERN_KEYS[p]; return k ? t(k) : (p || ''); }
  function bindActionButtons() {
    var patternBtns = document.querySelectorAll('.pattern-btn');
    patternBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!activeGamaId) return;
        var opts = {
          pattern: btn.dataset.pattern,
          aisleMM: (parseFloat(document.getElementById('opt-aisle').value) || 90) * 10,
          backToBack: !!document.getElementById('opt-backtoback').checked,
          stackAxis: document.getElementById('opt-aisledir').value
        };
        var res = autoFill(activeGamaId, activeCfg, opts);
        showToast(res.placed
          ? (t('placed_n').replace('{n}', res.placed).replace('{pattern}', patternLabel(opts.pattern)) +
             (res.capped ? (' ' + t('placed_capped')) : ''))
          : t('placed_none'));
        normalizeChainedUnitTypes(); redrawPlanIfActive();
      });
    });

    // "Distribución óptima": del panel solo se lee el PASILLO — el patrón, el eje
    // y el espalda-con-espalda los decide la búsqueda. El cálculo va en un
    // setTimeout para que el navegador pinte antes el aviso "Calculando…": las 16
    // simulaciones son síncronas y, sin ceder el hilo, el toast no se vería.
    var optBtn = document.getElementById('pattern-optimal-btn');
    if (optBtn) optBtn.addEventListener('click', function () {
      if (!activeGamaId) return;
      var aisleEl = document.getElementById('opt-aisle');
      var aisleMM = ((aisleEl && parseFloat(aisleEl.value)) || 90) * 10;
      showToast(t('calculating'));
      setTimeout(function () {
        var res = autoFillOptimal(activeGamaId, activeCfg, { aisleMM: aisleMM });
        // El óptimo elige también la ALTURA y los NIVELES que mejor aprovechan el
        // alto del espacio, y lo hace mutando `activeCfg`: hay que repintar los
        // selects o el panel seguiría enseñando la medida anterior.
        renderProductFields();
        if (!res.placed) { showToast(t('placed_none')); return; }
        // La UNIDAD del resumen depende de la gama: una estantería para palés no
        // tiene baldas, así que anunciar "158,4 m de balda" es información falsa.
        // Se elige la frase por la unidad que declara la capacidad de la gama.
        var gSel = SpaceCatalog.GAMAS[activeGamaId];
        var esPales = false, totalPales = 0;
        if (gSel && typeof gSel.capacity === 'function') {
          try {
            var capSel = gSel.capacity(activeCfg);
            esPales = !!(capSel && capSel.unitKey === 'cap_unit_pallet' && capSel.count);
            if (esPales) totalPales = capSel.count * res.placed;
          } catch (e) { esPales = false; }
        }
        var msg = t(esPales ? 'optimal_applied_pales' : 'optimal_applied')
          .replace('{pattern}', patternLabel(res.pattern))
          .replace('{n}', res.placed)
          // Con una config degenerada (sin niveles) no hay metros de balda que
          // anunciar: mejor omitir el dato que soltar un "0.0 m" que parece un error.
          .replace('{m}', esPales ? totalPales : (res.capacityMM > 0 ? (res.capacityMM / 1000).toFixed(1) : '—'));
        if (res.mixed) msg += ' — ' + t('optimal_mixed');
        if (res.capped) msg += ' ' + t('placed_capped');
        showToast(msg);
        // OJO: NO se llama aquí a refreshOverlapState()/refreshPricesAndTotals().
        // El autoFill() que acaba de aplicar el ganador ya las ha llamado, y
        // getPriceFor() solo consulta priceCache (que se escribe al COMPLETAR el
        // fetch, sin dedupe en vuelo): repetirlas pedía CADA precio dos veces, y
        // en un mercado donde el handle traducido no existe cada duplicado arrastra
        // la cadena de búsqueda por SKU (hasta ~130 peticiones más).
        normalizeChainedUnitTypes(); redrawPlanIfActive();
      }, 30);
    });

    var am = document.getElementById('add-manual-btn');
    if (am) am.addEventListener('click', function () {
      if (!activeGamaId) return;
      var gama = SpaceCatalog.GAMAS[activeGamaId];
      if (gama.canUseUnitType && activeCfg.unitType && !gama.canUseUnitType(activeCfg.unitType, activeCfg, items)) {
        showToast(t('chain_need_inicial'));
        return;
      }
      // No se coloca lo que no cabe de alto: se explica con las dos cifras (lo que
      // mide tu espacio y lo que necesita la estantería) en vez de un "no se puede".
      if (!cfgFitsRoomHeight(activeGamaId, activeCfg)) {
        showToast(t('fit_alto_msg')
          .replace('{sala}', Math.round(room.heightMM / 10))
          .replace('{alto}', Math.round(gama.footprintMM(activeCfg).height / 10)));
        return;
      }
      var created = addItem(activeGamaId, activeCfg, room.widthMM / 2, room.depthMM / 2, 0);
      selectItem(created.id);
      refreshOverlapState(); refreshPricesAndTotals();
      // Red de seguridad: si aun así queda colgando (p.ej. se soltó lejos de
      // cualquier Inicial compatible), se autocorrige a Inicial — nunca se deja inválida.
      normalizeChainedUnitTypes(); redrawPlanIfActive();
    });
    var vt = document.getElementById('view-toggle-btn'); if (vt) vt.addEventListener('click', toggleViewMode);
    var cart = document.getElementById('add-to-cart-btn'); if (cart) cart.addEventListener('click', addAllToCart);
    var pdf = document.getElementById('budget-pdf-btn'); if (pdf) pdf.addEventListener('click', prepareBudget);
    var shareBtn = document.getElementById('share-btn'); if (shareBtn) shareBtn.addEventListener('click', copyShareUrl);
    var contactBtn = document.getElementById('contact-btn'); if (contactBtn) contactBtn.addEventListener('click', function () { window.location.href = buildContactMailto(); });
    var rot = document.getElementById('tb-rotate'); if (rot) rot.addEventListener('click', rotateSelected);
    var dup = document.getElementById('tb-duplicate'); if (dup) dup.addEventListener('click', duplicateSelected);
    var del = document.getElementById('tb-delete'); if (del) del.addEventListener('click', deleteSelected);

    var mView = document.getElementById('mode-view-btn'); if (mView) mView.addEventListener('click', function () { setEditMode(false); });
    var mEdit = document.getElementById('mode-edit-btn'); if (mEdit) mEdit.addEventListener('click', function () { setEditMode(true); });
    var delAll = document.getElementById('delete-all-btn'); if (delAll) delAll.addEventListener('click', function () {
      if (!items.length) return;
      clearAllItems(); refreshPricesAndTotals(); redrawPlanIfActive();
    });
    var camFront = document.getElementById('cam-front'); if (camFront) camFront.addEventListener('click', function () { setCameraPreset('front'); });
    var camSide = document.getElementById('cam-side'); if (camSide) camSide.addEventListener('click', function () { setCameraPreset('side'); });
    var camTop = document.getElementById('cam-top'); if (camTop) camTop.addEventListener('click', function () { setCameraPreset('top'); });
    var camReset = document.getElementById('cam-reset'); if (camReset) camReset.addEventListener('click', function () { setCameraPreset('iso'); });
    var camFit = document.getElementById('cam-fit'); if (camFit) camFit.addEventListener('click', fitAllItems);
  }

  // ─── Init / boot ────────────────────────────────────────────────────────────
  function init() {
    if (!window.SpaceCatalog) { console.error('[SpaceConfigurator] SpaceCatalog no encontrado'); return; }
    var canvas = document.getElementById('configurator-canvas'); if (!canvas) return;
    var viewerEl = canvas.parentElement;
    var sharedConfig = readShareConfig();
    if (sharedConfig) {
      room.widthMM = sharedConfig.room.w; room.depthMM = sharedConfig.room.d; room.heightMM = sharedConfig.room.h;
    }

    renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.1;
    renderer.setSize(canvas.clientWidth || viewerEl.clientWidth, canvas.clientHeight || viewerEl.clientHeight, false);

    scene = new THREE.Scene();
    scene.background = new THREE.Color(0xFFFFFF);

    var w0 = canvas.clientWidth || viewerEl.clientWidth, h0 = canvas.clientHeight || viewerEl.clientHeight;
    perspCam = new THREE.PerspectiveCamera(45, w0 / h0, 0.05, 200);
    camera = perspCam;

    scene.add(new THREE.AmbientLight(0xFFFFFF, 0.9));
    var keyLight = new THREE.DirectionalLight(0xFFFFFF, 1.0); keyLight.position.set(4, 10, 6); scene.add(keyLight);
    var fillLight = new THREE.DirectionalLight(0xF0F5FF, 0.4); fillLight.position.set(-4, 4, -3); scene.add(fillLight);

    loader = new THREE.GLTFLoader();
    if (THREE.Cache) THREE.Cache.enabled = true;

    controls = new THREE.OrbitControls(perspCam, renderer.domElement);
    controls.enableDamping = true; controls.dampingFactor = 0.08;
    controls.maxPolarAngle = Math.PI / 2 - 0.02;

    raycaster = new THREE.Raycaster();
    initDimLabels(viewerEl);

    buildRoom();
    frameCameraToRoom();
    setEditMode(false);

    renderGamaPicker();
    renderProductFields();
    renderEditPanel();
    bindRoomInputs();
    bindActionButtons();

    renderer.domElement.addEventListener('pointerdown', onPointerDown);
    var planCanvasEl = document.getElementById('plan-canvas');
    if (planCanvasEl) planCanvasEl.addEventListener('pointerdown', onPointerDown);
    // En window (no solo el canvas): un arrastre rápido que sale del canvas no
    // debe "congelarse" — las coordenadas NDC siguen siendo válidas fuera de -1..1.
    window.addEventListener('pointermove', onPointerMoveGlobal);
    window.addEventListener('pointerup', onPointerUpGlobal);
    window.addEventListener('resize', onResize);

    animate();

    if (sharedConfig && sharedConfig.items.length) {
      sharedConfig.items.forEach(function (it) {
        try { addItem(it.g, it.c, it.x, it.z, it.r); } catch (e) { console.error('[SpaceConfigurator] No se pudo restaurar un item compartido', e); }
      });
      refreshOverlapState(); refreshPricesAndTotals(); normalizeChainedUnitTypes(); redrawPlanIfActive();
      showToast(t('share_loaded'));
    }

    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      window.__SC = {
        get scene() { return scene; }, get camera() { return camera; }, get room() { return room; },
        get items() { return items; }, get controls() { return controls; }, get renderer() { return renderer; },
        get selectedItemId() { return selectedItemId; }, get dragCandidateId() { return dragCandidateId; },
        get _pointerDownOnCanvas() { return _pointerDownOnCanvas; }, get isDragging() { return isDragging; },
        get planViewTransform() { return planViewTransform; }, get viewMode() { return viewMode; },
        // Reparto/simulación: permiten barrer combinaciones y puntuar
        // distribuciones desde un harness, sin navegador ni GLB.
        makeDrySink: makeDrySink, packRun: packRun, packRunOptimized: packRunOptimized,
        autoFillOptimal: autoFillOptimal, rectFromFootprint: rectFromFootprint,
        widthFieldOf: widthFieldOf,
        THREE: THREE
      };
    }
  }

  function waitForLibraries(cb, elapsed) {
    elapsed = elapsed || 0;
    if (window.THREE && THREE.OrbitControls && THREE.GLTFLoader) { cb(); return; }
    if (elapsed > 10000) { console.error('[SpaceConfigurator] Three.js no cargó a tiempo'); return; }
    setTimeout(function () { waitForLibraries(cb, elapsed + 100); }, 100);
  }
  function boot() { waitForLibraries(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

})();
